import React, { useState, useRef, useCallback, useMemo } from "react";
import { Icon, Style, Stroke } from "ol/style.js";
import { fromLonLat } from "ol/proj";
import { useGetVariablesDataQuery, useGetVehiclesTrackingQuery } from "../services";
import { useGetPluginsQuery } from "../../ManagementPortal/services";
import { PluginContainer } from "../../Plugins";
import { VehicleDetailsWindowView } from "./VehicleDetailsWindowView";
import { VehicleMap } from "./VehicleMap";
import { VehicleTrack } from "./VehicleTrack";
import { VehicleList } from "./VehicleList";
import { Dnd, MinimisedTab, useDndContainer, WindowTab } from "../Dnd";
import { locationImg, locArrowImg } from "../assets/mapIcons";
import { googleDirectionIcon } from "../googleDirectionIcon";
import { useEffect } from "react";
import { useWebSocket, usePagination, useVehicleTelemetry } from "../../../hooks";
import {
  QIAutoMapIndicator,
  QICustomDateRangePicker,
  QIDragAndDropDetails,
  QISwitch,
} from "../../../components";
import moment from "moment";
import { TripsContainer } from "./Trips";
import { EventsContainer } from "./Events";
//Data config json
import { HeaderDetails, ListDetails } from "../Shared/VehicleDetailsItems";
import { SelectedAssetSummary } from "../Shared";
import { LiveStatusIndicator } from "../Shared/LiveStatusIndicator";
//Toast Message
import { ToastContainer, toast } from "react-toastify";
import mapboxgl from "mapbox-gl";
import "react-toastify/dist/ReactToastify.css";
import {
  debounce,
  getRotation,
  sortAndRemoveDuplicatesByTimestamp,
  renderQiMapLabels,
  clearQiMapLabels,
  generateDirectionalArrowPoints,
} from "../utils";
import { removeDuplicates } from "../utils";
import { startPointMarkerNew, homeLocation, direction, directionArrow } from "../assets";
import {
  getRenderableTrackingPoints,
  getVehicleDeviceDataTimestamp,
  getVehicleSpeedTimestamp,
  resolveTrackingStatus,
  MOVEMENT_STATUS_PRESENTATION,
} from "../utils";
import { useMapClustering } from "../useMapClustering";
import {
  renderQiMapClusterMarkers,
  clearQiMapClusterMarkers,
  renderMapboxClusters,
  renderGoogleMapClusters,
} from "../clusterRenderers";
import { isCluster as isClusterFeature } from "../clusterUtils";
import {
  getMapViewport,
  getOverviewFitZoom,
  getVisibleClusters,
  selectOverviewPointsToDraw,
} from "../clusterUtils";

//TrackPoints
import LiveTrackPoints from "./TrackPoints";
import { HistoryTrackPoints } from "./TrackPoints";
import { mergeChronologicalTrackPoints } from "./TrackPoints/helper";

//Raw Data
import { RawData } from "./RawData";
//Trips
import Activities from "./Activities";
//Graphs
import { GraphsContainer } from "../Graphs";
import { useDispatch, useSelector } from "react-redux";
import {
  setVariableDatas,
  setCurrentTabGlobal,
  setGlobalResetCount,
  setLiveTrackData,
} from "../../../reduxStore/features";
import { getLocalizedString } from "../../../shared/translation";
import TripsMap from "../Trips/TripsMap";
import EventsMap from "../Events/EventMap";
import { HorizontalScroll } from "../Shared/HorizontalScroll";
import { closeVehiclePopout } from "./popoutActions";
import {
  attachQiMapManualInteractionListeners,
  shouldAttachMapListeners,
  shouldCenterOnLatestVehiclePosition,
} from "../mapViewportPolicy";

// Keep the loading fallback stable so effects depending on trackingData run once.
const EMPTY_TRACKING_DATA = { data: [] };

export const VehicleContainer = () => {
  const dispatch = useDispatch();
  let selectedRange = useSelector((state) => state.common.selectedRange);
  let globalResetCount = useSelector((state) => state.common.globalResetCount);
  let trackpointsSelectedRange = useSelector((state) => state.common.globalLiveLastDataTime);
  let configJson = useSelector((state) => state.common.globalCustomJson);
  let globalDockAlign = useSelector((state) => state.common.globalDockAlign);

  const [clientId, setClientId] = useState(null);
  const [mapRef, setMapRef] = useState(null);
  const [mapProvider, setMapProvider] = useState();
  const [mapboxAccessToken, setMapBoxAccessToken] = useState();
  const [googleMapsApiKey, setGoogleMapsApiKey] = useState();
  const [showDetails, setShowDetails] = useState(false);
  const [deviceData, setDeviceData] = useState(null);
  const [deviceId, setDeviceId] = useState(null);
  const [sourceIds, setSourceIds] = useState([]);
  const [count, setCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState(0);
  const [mapData, setMapData] = useState({});
  const [trackingPoints, setTrackingPoints] = useState([]);
  const [selectedVehiclePlate, setselectedVehiclePlate] = useState(null);
  const [highlight, setHighlight] = useState(null);
  const [dockAlign, setDockAlign] = useState(null);
  const [mapExpand, setMapExpand] = useState(false);
  const [showTrack, setShowTrack] = useState(false);
  const [trackMapRef, setTrackMapRef] = useState(null);
  const [simpleSearch, setSimpleSearch] = useState("");
  const previousSearchRef = useRef("");
  const [currentTab, setCurrentTab] = useState("Map");
  const [trackpointsHistoryData, setTrackpointsHistoryData] = useState([]);
  const [liveRoutePoints, setLiveRoutePoints] = useState([]);

  const [selectedRangeHistory, setSelectedRangeHistory] = useState({
    startDate: moment().subtract(1, "hours"),
    endDate: moment(),
  });
  const [selectedRangeLive, setSelectedRangeLive] = useState({
    startDate: moment().subtract(trackpointsSelectedRange, "minutes"),
    endDate: moment(),
  });
  const [resetCount, setResetCount] = useState(0);
  const [selectedRowId, setSelectedRowId] = useState(null);
  // Config Set
  const [clientConfig, setClientConfig] = useState({});
  const [maximizeMinimize, setmaximizeMinimize] = useState(false);
  const [toggleTrackPointTab, setToggleTrackPointTab] = useState(false);
  const [decode, setDecode] = useState(false);
  const [order, setOrder] = useState(false);
  const [variableData, setVariableData] = useState({});
  const [variablePage, setVariablePage] = useState(0);
  const [vehicleData, setVehicleData] = useState(null);
  const [initialLoad, setInitialLoad] = useState(true); // Flag to check if initial load
  const [mapPoint, setMapPoint] = useState(null);
  const [vehiclesData, setVehiclesData] = useState([]); // Stores vehicles plate no and associated device imei
  const [sortedDataDisplay, setSortedDataDisplay] = useState(true);
  const [plateSort, setPlateSort] = useState("");
  const [nonAdminUserId, setNonAdminUserId] = useState("");
  const [lastRefreshTime, setLastRefreshTime] = useState(Date.now());
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [showEventsDetails, setShowEventsDetails] = useState(null);
  const [liveTrackingData, setLiveTrackingData] = useState([]);
  const [liveDetailsBlockView, setLiveDetailsBlockView] = useState("TrackPoints");
  const [selectedTrackPointData, setSelectedTrackPointData] = useState(null);
  const [isTrackPointsHistoryDataCollected, setIsTrackPointsHistoryDataCollected] = useState(false);
  const [liveTime, setLiveTime] = useState();
  const [userHasAdjustedMap, setUserHasAdjustedMap] = useState(false);
  const [currentMapZoom, setCurrentMapZoom] = useState(null);
  const [currentMapCenter, setCurrentMapCenter] = useState(null);
  const [isInitialVehicleLoad, setIsInitialVehicleLoad] = useState(true);
  const [wasVehicleSelected, setWasVehicleSelected] = useState(false);
  const overviewFitCompletedRef = useRef(false);
  const prevSelectedVehiclePlateRef = useRef(null);
  const qiMapListenerTargetRef = useRef(null);
  const googleMapListenerTargetRef = useRef(null);
  const [mapResetCount, setMapResetCount] = useState(1);
  const [changedSelectedDevice, setChangedSelectedDevice] = useState(false);

  //Calculate Latest Date
  /* useEffect(() => {
    try {
      setSelectedRangeHistory({
        startDate: moment().subtract(24, "hours"),
        endDate: moment(),
      });
    } catch (e) {}
  }, [deviceId]); */

  const openDeviceModal = () => {
    setShowDetails(false);
    addNewBox(100);
  };
  const { realTimedata, latestDeviceData: latestRealtimeDeviceData } = useWebSocket(
    String(clientId),
    "all",
    "sub_all",
    deviceId,
    "plate_number",
    deviceId,
    selectedVehiclePlate,
  );

  // Resolve the client id once on mount. Kept separate from the provider effect
  // below so the WebSocket clientId is not torn down (and re-created) every time
  // the Redux config json changes.
  useEffect(() => {
    const selectedClientId = JSON.parse(localStorage.getItem("selected-app-id"));
    const currentUser = JSON.parse(localStorage.getItem("current-user"))?.client_apps?.find(
      (item) => {
        return item.id === selectedClientId;
      },
    );
    setClientId(currentUser?.client?.id);

    //clean up client id on component unmount
    return () => setClientId(null);
  }, []);

  // Wait for CommonHeader to load the config; an empty object is a valid client config.
  useEffect(() => {
    if (configJson == null) return;

    try {
      const mapProvider = configJson?.tracking?.web?.map;
      const clientConfig = configJson;

      if (mapProvider?.provider === "mapbox" && mapProvider?.mapboxAccessToken) {
        setClientConfig(clientConfig);
        setMapProvider("mapbox");
        setMapBoxAccessToken(mapProvider.mapboxAccessToken);
        setGoogleMapsApiKey(null);
      } else if (mapProvider?.provider === "google" && mapProvider?.googleMapsApiKey) {
        setClientConfig(clientConfig);
        setMapProvider("google");
        setMapBoxAccessToken(null);
        setGoogleMapsApiKey(mapProvider.googleMapsApiKey);
      } else {
        setClientConfig(clientConfig);
        setMapProvider("qiMap");
        setMapBoxAccessToken(null);
        setGoogleMapsApiKey(null);
      }
    } catch (e) {
      console.log(e);
    }
  }, [configJson]);

  const [q, setQ] = useState("");
  const [page1, setPage1] = useState(1);
  const [perPage1, setPerPage1] = useState(20);
  const pagination = {
    page: page1,
    perPage: perPage1,
    onPageChange: setPage1,
    onPerPageChange: setPerPage1,
  };

  // When page changes, any selected row should be removed
  useEffect(() => {
    if (currentTab === "RawData") {
      setCurrentTab("Map");
    }
    setSelectedRowId(null);
    removeLayerOnClose();
    setDeviceId(null);
    setDockAlign("cross");
  }, [page1]);

  // When page changes from active to all and vice versa, any selected row should be removed
  useEffect(() => {
    if (currentTab === "RawData") {
      setCurrentTab("Map");
    }
    setSelectedRowId(null);
    removeLayerOnClose();
    setDeviceId(null);
    setDockAlign("cross");
  }, [sortedDataDisplay]);

  useEffect(() => {
    if (sortedDataDisplay) {
      setQ(simpleSearch);
    } else {
      let obj = {
        name_or_plate_number_cont: simpleSearch.toUpperCase(),
        filter_device_imei_cont: simpleSearch.toUpperCase(),
        m: "or",
      };
      setQ(encodeURIComponent(JSON.stringify(obj)));
    }
    setPage1(1);
  }, [simpleSearch]);

  useEffect(() => {
    if (sortedDataDisplay) {
      setQ(simpleSearch);
    } else {
      let obj = {
        name_or_plate_number_cont: simpleSearch.toUpperCase(),
        filter_device_imei_cont: simpleSearch.toUpperCase(),
        m: "or",
      };
      setQ(encodeURIComponent(JSON.stringify(obj)));
    }
    setPage1(1);
  }, [simpleSearch]);

  useEffect(() => {
    setSimpleSearch("");
    setPage1(1);
    setPerPage1(20);
    if (sortedDataDisplay) {
      setQ("");
    } else {
      let obj = {
        name_or_plate_number_cont: simpleSearch.toUpperCase(),
        filter_device_imei_cont: simpleSearch.toUpperCase(),
        m: "or",
      };
      setQ(encodeURIComponent(JSON.stringify(obj)));
    }
  }, [sortedDataDisplay]);

  const getQueryParams = () => {
    if (sortedDataDisplay && nonAdminUserId !== "") {
      return {
        page: pagination?.page - 1,
        per_page: pagination?.perPage,
        filter: true,
        plate_numbers: sourceIds,
        q: q,
        sort: plateSort && `plate_number:${plateSort}`,
      };
    } else if (sortedDataDisplay && nonAdminUserId === "") {
      return {
        page: pagination?.page - 1,
        per_page: pagination?.perPage,
        filter: true,
        q: q,
        sort: plateSort && `plate_number:${plateSort}`,
      };
    } else if (!sortedDataDisplay && nonAdminUserId !== "") {
      return {
        page: pagination?.page - 1,
        per_page: pagination?.perPage,
        plate_numbers: sourceIds,
      };
    } else if (!sortedDataDisplay && nonAdminUserId === "") {
      return {
        page: pagination?.page - 1,
        per_page: pagination?.perPage,
      };
    }
  };

  // Store the interval ID to manage it properly
  const refreshIntervalRef = useRef(null);
  const nextRefreshTimeRef = useRef(null);

  // Auto refresh the tracking data every 15 seconds
  useEffect(() => {
    // Keep the background list fresh while a vehicle details view is open.
    const shouldPoll = sortedDataDisplay && !simpleSearch && !plateSort;

    if (shouldPoll) {
      const performRefresh = () => {
        setIsRefreshing(true);
        setLastRefreshTime(Date.now());
        nextRefreshTimeRef.current = Date.now() + 15000; // Set next refresh time

        // Reset the refreshing state after a more visible delay to show the animation
        setTimeout(() => {
          setIsRefreshing(false);
        }, 2000);
      };

      // Set initial next refresh time if not set
      if (!nextRefreshTimeRef.current) {
        nextRefreshTimeRef.current = Date.now() + 15000;
      }

      refreshIntervalRef.current = setInterval(performRefresh, 15000);

      return () => {
        if (refreshIntervalRef.current) {
          clearInterval(refreshIntervalRef.current);
          refreshIntervalRef.current = null;
        }
      };
    } else {
      // Clear interval when polling should not be active
      if (refreshIntervalRef.current) {
        clearInterval(refreshIntervalRef.current);
        refreshIntervalRef.current = null;
      }
    }
  }, [sortedDataDisplay, simpleSearch, plateSort]);

  // Store previous values to detect changes
  const prevFilterActiveRef = useRef(Boolean(simpleSearch || plateSort));

  /* Get vehicle position and plot in map */
  const { data: trackingData = EMPTY_TRACKING_DATA, currentData: currentTrackingData, refetch } = useGetVehiclesTrackingQuery(
    getQueryParams(),
    {
      pollingInterval: sortedDataDisplay && !simpleSearch && !plateSort ? 15000 : 0,
      refetchOnMountOrArgChange: true,
    },
  );

  /**
   * Canonical field-level telemetry store (spec `vehicle-realtime-data-consistency`,
   * design steps 6-9). Called exactly ONCE for the tracking page: the sidebar, the
   * map labels and the live summary all read the same reconciled `movement` object,
   * so they can no longer disagree because of response order (#119201) and movement
   * freshness always comes from the speed observation itself (#119052).
   */
  const {
    getCurrentMovementByPlateNumber,
    getCurrentTelemetryByPlateNumber,
    getTableDataByPlateNumber,
    getNewestSpeedRowByPlateNumber,
    hydrateRoute,
  } = useVehicleTelemetry({
    latestVehicleData: trackingData?.latest_data,
    realtimeByPlate: realTimedata,
    selectedPlateNumber: selectedVehiclePlate,
  });

  /**
   * Resolves one vehicle's movement status and duration timestamp from the canonical
   * store. The status icon and the duration label are always derived from the SAME
   * timestamp, so they cannot contradict each other (bugfix.md 2.4); with no valid
   * observation the asset remains Offline/Never.
   *
   * `fallback` is only used for a plate the store has not reconciled yet (it has no
   * `movement`): status is then recomputed from the fallback timestamp instead of
   * keeping a status resolved from a different one.
   */
  const resolveCanonicalStatus = useCallback(
    (plateNumber, fallback = {}) => {
      const movement = getCurrentMovementByPlateNumber(plateNumber);
      const telemetry = getCurrentTelemetryByPlateNumber(plateNumber);
      const ignition = telemetry?.ignition ? telemetry.ignition.value : fallback.ignition;
      const fallbackMovement = fallback.rawSpeed == null
        ? null
        : { speed: fallback.rawSpeed, observedAt: fallback.observedAt };
      const { observedAt, rawSpeed, movementStatus } = resolveTrackingStatus(
        movement ?? fallbackMovement,
        ignition,
        fallback.deviceDataAt,
      );

      return {
        movement,
        telemetry,
        observedAt,
        rawSpeed,
        ignition,
        movementStatus,
        statusPresentation:
          MOVEMENT_STATUS_PRESENTATION[movementStatus] || MOVEMENT_STATUS_PRESENTATION.offline,
      };
    },
    [getCurrentMovementByPlateNumber, getCurrentTelemetryByPlateNumber],
  );

  /**
   * Applies the canonical movement to a map point so marker colour, icon and the
   * duration tooltip are all derived from the same `movement.observedAt`
   * (design step 9). A point whose plate is unknown to the store keeps its own values.
   */
  const applyCanonicalStatusToPoint = useCallback(
    (point = {}) => {
      const canonical = resolveCanonicalStatus(point?.plate_number, {
        observedAt: point?.source_time ?? point?.lastUpdated ?? null,
        deviceDataAt: point?.source_time ?? point?.lastUpdated ?? null,
        rawSpeed: point?.rawSpeed,
        ignition: point?.ignition,
      });

      return {
        ...point,
        ignition: canonical.ignition,
        rawSpeed: canonical.rawSpeed,
        source_time: canonical.observedAt,
        lastUpdated: canonical.observedAt,
        movementStatus: canonical.movementStatus,
        statusColor: canonical.statusPresentation.color,
        statusIcon: canonical.statusPresentation.icon,
      };
    },
    [resolveCanonicalStatus],
  );

  /**
   * Route hydration bridge (design step 7). TrackPoints reports the whole route
   * page it loaded; the packets are merged into the canonical store by observation
   * time, so a route row newer than the latest aggregate updates the sidebar too.
   */
  const handleRoutePackets = useCallback(
    (plateNumber, packets) => {
      if (!plateNumber || !packets) return;
      hydrateRoute(plateNumber, Array.isArray(packets) ? packets : [packets]);
    },
    [hydrateRoute],
  );

  /**
   * Canonical telemetry passed down to the child surfaces. ListCard (task 3.8),
   * TrackPoints and the live summary header (task 3.9) read the same getters
   * instead of recomputing speed and status from the raw responses.
   */
  const canonicalTelemetry = useMemo(
    () => ({
      getCurrentMovementByPlateNumber,
      getCurrentTelemetryByPlateNumber,
      getTableDataByPlateNumber,
      getNewestSpeedRowByPlateNumber,
      hydrateRoute,
    }),
    [
      getCurrentMovementByPlateNumber,
      getCurrentTelemetryByPlateNumber,
      getTableDataByPlateNumber,
      getNewestSpeedRowByPlateNumber,
      hydrateRoute,
    ],
  );

  // Resume refresh when search or plate sorting is cleared
  useEffect(() => {
    const wasFilterPreviouslyActive = prevFilterActiveRef.current && !simpleSearch && !plateSort;
    const shouldPoll = sortedDataDisplay && !simpleSearch && !plateSort;

    // Update refs for next comparison
    prevFilterActiveRef.current = Boolean(simpleSearch || plateSort);

    // If polling should be active and the filter was just cleared
    if (shouldPoll && wasFilterPreviouslyActive) {
      const currentTime = Date.now();

      // Calculate remaining time until next scheduled refresh
      const timeUntilNextRefresh = nextRefreshTimeRef.current
        ? Math.max(0, nextRefreshTimeRef.current - currentTime)
        : 0;

      if (timeUntilNextRefresh === 0) {
        // If it's time to refresh or past time, refresh immediately
        setIsRefreshing(true);
        setLastRefreshTime(currentTime);
        nextRefreshTimeRef.current = currentTime + 15000;

        refetch();

        setTimeout(() => {
          setIsRefreshing(false);
        }, 2000);
      } else {
        // Set a timeout for the remaining time until next refresh
        const timeoutId = setTimeout(() => {
          setIsRefreshing(true);
          setLastRefreshTime(Date.now());
          nextRefreshTimeRef.current = Date.now() + 15000;

          refetch();

          setTimeout(() => {
            setIsRefreshing(false);
          }, 2000);
        }, timeUntilNextRefresh);

        // Clean up timeout if component unmounts or conditions change
        return () => clearTimeout(timeoutId);
      }
    }
  }, [simpleSearch, plateSort, sortedDataDisplay, refetch]);

  /* Get Variable Data Mappings */

  const { data: mappingData } = useGetVariablesDataQuery({ per_page: 2000, page: variablePage });

  /* Load data to get data for show details */
  useEffect(() => {
    let device;
    if (trackingData && trackingData?.latest_data?.length) {
      let deviceIds = [];
      let tempVehicleData = [];
      let trackingPoints = [];

      // Sort the tracking data by the latest time if sortedDataDisplay is true
      const sortedTrackingData = trackingData.latest_data;

      sortedTrackingData.map((datum) => {
        let flag = 1;
        let deviceSourceId = null;
        let plateNo = null;
        let ignition = null;
        let speed = null;

        // Get source_id if available
        if (
          datum?.device_data?.source_id ||
          datum?.device_reply?.source_id ||
          datum?.login?.source_id ||
          datum?.registration?.source_id ||
          datum?.heartbeat?.source_id
        ) {
          if (datum?.registration) {
            if (datum?.registration?.plate_number?.v) {
              deviceSourceId = datum?.registration?.source_id;
            }
          }
          deviceSourceId =
            datum?.device_data?.source_id ||
            datum?.device_reply?.source_id ||
            datum?.login?.source_id ||
            datum?.registration?.source_id ||
            datum?.heartbeat?.source_id;
          deviceIds.push(deviceSourceId);
        }

        // Get plate number if available
        if (
          datum?.device_data?.plate_number?.v ||
          datum?.device_reply?.plate_number?.v ||
          datum?.login?.plate_number?.v ||
          datum?.registration?.plate_number?.v ||
          datum?.heartbeat?.plate_number?.v
        ) {
          if (datum?.registration) {
            if (datum?.registration?.plate_number?.v) {
              plateNo = datum?.registration?.plate_number?.v;
            }
          }
          plateNo =
            datum?.device_data?.plate_number?.v ||
            datum?.device_reply?.plate_number?.v ||
            datum?.login?.plate_number?.v ||
            datum?.registration?.plate_number?.v ||
            datum?.heartbeat?.plate_number?.v;
        }

        if (datum?.device_data?.ignition?.v !== undefined) {
          ignition = datum.device_data.ignition.v;
        }

        if (datum?.device_data?.velocity?.v) {
          speed =
            datum?.device_data?.velocity?.v?.speed === 0
              ? 0
              : datum?.device_data?.velocity?.v?.speed;
        }

        const position = datum?.device_data?.gps?.v?.position;
        const direction = datum?.device_data?.velocity?.v?.direction;

        // Add vehicle to list if we have either source_id or plate number
        if (deviceSourceId || plateNo) {
          // Speed, movement status and the duration label all come from the canonical
          // store, which reconciles the latest aggregate, the route response and
          // SignalR by speed observation time (design step 8). The aggregate values
          // read above are only the fallback for a plate the store has not seen,
          // and its freshness comes from device_data.velocity.t (#119052).
          const canonical = resolveCanonicalStatus(plateNo, {
            observedAt: getVehicleSpeedTimestamp(datum),
            deviceDataAt: getVehicleDeviceDataTimestamp(datum),
            rawSpeed: speed,
            ignition,
          });
          const statusTime = canonical.observedAt;
          const rawSpeed = canonical.rawSpeed;
          const statusIgnition = canonical.ignition;
          const movementStatus = canonical.movementStatus;
          const statusPresentation = canonical.statusPresentation;
          const displaySpeed =
            rawSpeed === 0 ? "0 km/h" : rawSpeed && `${(rawSpeed * 3.6).toFixed(1)} km/h`;

          tempVehicleData?.push({
            device_name_list: deviceSourceId || "N/A",
            plate_number: plateNo || "N/A",
            id: deviceSourceId
              ? `${deviceSourceId}_${plateNo || "N/A"}`
              : `no_source_${plateNo || "N/A"}`,
            // Duration label shares the resolved time with the status icon.
            lastUpdated: statusTime,
            ignition: statusIgnition,
            speed: displaySpeed,
            rawSpeed,
            movementStatus,
            statusColor: statusPresentation.color,
            statusIcon: statusPresentation.icon,
          });
          trackingPoints.push({
            ...position,
            id: deviceSourceId
              ? `${deviceSourceId}_${plateNo || "N/A"}`
              : `no_source_${plateNo || "N/A"}`,
            device_name_list: deviceSourceId || "N/A",
            imei: deviceSourceId
              ? `${deviceSourceId}_${plateNo || "N/A"}`
              : `no_source_${plateNo || "N/A"}`,
            direction,
            speed: displaySpeed,
            rawSpeed,
            source_time: statusTime,
            ignition: statusIgnition,
            plate_number: plateNo || "N/A",
            movementStatus,
            statusColor: statusPresentation.color,
            statusIcon: statusPresentation.icon,
          });
        }
      });

      setVehiclesData(tempVehicleData);
      setTrackingPoints(trackingPoints.filter((device) => device.lat !== 0 && device.lng !== 0));

      device = (sortedTrackingData || [])?.find(
        ({ device_data }) => device_data?.plate_number?.v === selectedVehiclePlate,
      );
      if (selectedVehiclePlate && device?.device_data) {
        setDeviceData(device.device_data);
      } else if (!selectedVehiclePlate) {
        setDeviceData({});
      }
    }
    if (trackingData && !trackingData?.latest_data?.length) {
      setDeviceData({});
      setVehiclesData([]);
      setTrackingPoints([]);
    }
  }, [trackingData, resolveCanonicalStatus, lastRefreshTime, deviceId, selectedVehiclePlate]);

  // Returns the latest time
  const getLatestTime = (t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12) => {
    let validTime1 = 0,
      validTime2 = 0,
      validTime3 = 0,
      validTime4 = 0,
      validTime5 = 0,
      validTime6 = 0,
      validTime7 = 0,
      validTime8 = 0,
      validTime9 = 0,
      validTime10 = 0,
      validTime11 = 0,
      validTime12 = 0;
    if (typeof t1 == "number") {
      validTime1 = t1;
    }
    if (typeof t2 == "number") {
      validTime2 = t2;
    }
    if (typeof t3 == "number") {
      validTime3 = t3;
    }
    if (typeof t4 == "number") {
      validTime4 = t4;
    }
    if (typeof t5 == "number") {
      validTime5 = t5;
    }
    if (typeof t6 == "number") {
      validTime6 = t6;
    }
    if (typeof t7 == "number") {
      validTime7 = t7;
    }
    if (typeof t8 == "number") {
      validTime8 = t8;
    }
    if (typeof t9 == "number") {
      validTime9 = t9;
    }
    if (typeof t10 == "number") {
      validTime10 = t10;
    }
    if (typeof t11 == "number") {
      validTime11 = t11;
    }
    if (typeof t12 == "number") {
      validTime12 = t12;
    }

    return Math.max(
      validTime1,
      validTime2,
      validTime3,
      validTime4,
      validTime5,
      validTime6,
      validTime7,
      validTime8,
      validTime9,
      validTime10,
      validTime11,
      validTime12,
    );
  };

  //Debounce to optimize performance

  const processTrackingData = useCallback(
    debounce((trackingData, realTimedata) => {
      const filteredPosition = {};
      const trackingPoints = [];

      trackingData.latest_data.forEach((data) => {
        const sourceId =
          data?.device_data?.source_id ||
          data?.heartbeat?.source_id ||
          data?.login?.source_id ||
          data?.registration?.source_id;

        const plateNo =
          data?.device_data?.plate_number?.v ||
          data?.device_reply?.plate_number?.v ||
          data?.login?.plate_number?.v ||
          data?.registration?.plate_number?.v ||
          data?.heartbeat?.plate_number?.v;

        const realTimeDataForSource = realTimedata[plateNo];
        const position =
          realTimeDataForSource?.gps?.position || data?.device_data?.gps?.v?.position;
        const direction =
          realTimeDataForSource?.velocity?.direction || data?.device_data?.velocity?.v?.direction;
        let speed =
          realTimeDataForSource?.velocity?.speed !== undefined
            ? realTimeDataForSource.velocity.speed
            : data?.device_data?.velocity?.v?.speed;

        const sourceTime = getLatestTime(
          mapData[sourceId]?.sourceTime,
          realTimeDataForSource?.source_time,
          data?.device_data?.source_time?.v,
          data?.device_data?.source_time,
          data?.heartbeat?.source_time?.v,
          data?.heartbeat?.source_time,
          data?.login?.source_time?.v,
          data?.login?.source_time,
          data?.device_reply?.source_time?.v,
          data?.device_reply?.source_time,
          data?.registration?.source_time?.v,
          data?.registration?.source_time,
        );

        const serverTime =
          realTimeDataForSource?.server_time ||
          data?.device_data?.server_time?.v ||
          data?.device_data?.server_time ||
          data?.heartbeat?.server_time?.v ||
          data?.heartbeat?.server_time ||
          data?.login?.server_time?.v ||
          data?.login?.server_time ||
          data?.device_reply?.server_time?.v ||
          data?.device_reply?.server_time ||
          data?.registration?.server_time?.v ||
          data?.registration?.server_time;
        const plate_number = data?.device_data?.plate_number?.v || data?.heartbeat?.plate_number?.v;

        const rawSpeed = speed;
        speed = speed == 0 || speed ? `${(speed * 3.6).toFixed(1)} km/h` : "Not Available";

        // Only set ignition to true if we have valid device data
        const hasValidDeviceData =
          data?.device_data?.ignition?.v !== undefined ||
          realTimeDataForSource?.ignition !== undefined;
        const ignition = hasValidDeviceData
          ? (realTimeDataForSource?.ignition ?? data?.device_data?.ignition?.v ?? "Unknown")
          : "Unknown";

        if (sourceId) {
          filteredPosition[sourceId] = {
            speed,
            rawSpeed,
            direction,
            ignition,
            sourceTime,
            plate_number,
            serverTime,
          };
          //trackingPoints.push({ ...position, imei: sourceId, direction, speed, plate_number });
        }
      });

      //setMapData(filteredPosition);
      //setTrackingPoints(trackingPoints.filter((device) => device.lat !== 0 && device.lng !== 0));
    }, 3000),
    [],
  );
  //Live Tracking
  useEffect(() => {
    if (latestRealtimeDeviceData[selectedVehiclePlate]) {
      const realTimeInfo = latestRealtimeDeviceData[selectedVehiclePlate];
      const maxHdopThreshold = 100; // Define HDOP threshold

      // Add GPS validation check
      if (
        !realTimeInfo?.gps ||
        !realTimeInfo?.gps?.position?.is_valid ||
        (realTimeInfo?.gps?.hdop && realTimeInfo?.gps?.hdop > maxHdopThreshold) ||
        realTimeInfo?.packet_type !== "device_data" ||
        !setIsTrackPointsHistoryDataCollected
      ) {
        return; // Skip invalid GPS data
      }

      const newTrackPoints = {
        ...realTimeInfo?.gps?.position,
        direction: realTimeInfo?.velocity?.direction,
        speed: realTimeInfo?.velocity?.speed,
        plate_number: selectedVehiclePlate,
        timestamp: moment(realTimeInfo?.source_time || new Date()).valueOf(),
      };
      setLiveTrackingData((prev) => sortAndRemoveDuplicatesByTimestamp(prev, newTrackPoints));
    }
  }, [
    latestRealtimeDeviceData,
    selectedVehiclePlate,
    trackpointsHistoryData,
    liveRoutePoints,
    setIsTrackPointsHistoryDataCollected,
  ]);

  useEffect(() => {
    if (!liveRoutePoints.length) return;
    setLiveTrackingData((previous) => changedSelectedDevice
      ? liveRoutePoints
      : mergeChronologicalTrackPoints(previous, liveRoutePoints));
    if (changedSelectedDevice) setChangedSelectedDevice(false);
  }, [liveRoutePoints, changedSelectedDevice]);

  useEffect(() => {
    if (deviceId) {
      setChangedSelectedDevice(true);
    }
  }, [deviceId]);

  // Process tracking data when it changes
  useEffect(() => {
    if (!trackingData?.latest_data) return;
    processTrackingData(trackingData, realTimedata);
  }, [
    mapRef,
    trackingPoints,
    deviceId,
    initialLoad,
    mapProvider,
    isRefreshing,
    liveTrackingData,
    trackpointsHistoryData,
  ]);

  // Auto-follow latest point when no user interaction (separate behavior)
  useEffect(() => {
    // Only auto-follow if:
    // 1. QI Map provider
    // 2. User hasn't manually adjusted the map (or we're on initial load)
    // 3. No specific vehicle is selected (general tracking view)
    // 4. Has tracking data to follow
    if (
      mapProvider !== "qiMap" ||
      overviewFitCompletedRef.current ||
      (!initialLoad && userHasAdjustedMap) ||
      selectedVehiclePlate ||
      !mapRef ||
      !trackingPoints?.length
    ) {
      return;
    }

    try {
      // Find the latest point from all tracking data
      let latestPoint = null;
      let latestTime = 0;

      // Check live tracking data first (most recent)
      if (liveTrackingData?.length) {
        const lastLivePoint = liveTrackingData[liveTrackingData.length - 1];
        if (lastLivePoint?.timestamp > latestTime) {
          latestTime = lastLivePoint.timestamp;
          latestPoint = lastLivePoint;
        }
      }

      // Check tracking points if no live data or for comparison
      if (trackingPoints?.length) {
        // For general tracking points, use the last one in the array
        // (assuming they're ordered by recency)
        const lastTrackingPoint = trackingPoints[trackingPoints.length - 1];
        if (lastTrackingPoint && (!latestPoint || !latestTime)) {
          latestPoint = lastTrackingPoint;
        }
      }

      // Update map center to latest point
      if (latestPoint && latestPoint.lat && latestPoint.lng) {
        const olMap = mapRef.getMapReference();
        if (olMap && olMap.getView) {
          const view = olMap.getView();
          if (view && view.setCenter) {
            const transformedLocation = fromLonLat([latestPoint.lng, latestPoint.lat]);

            // Temporarily disable user interaction tracking during programmatic changes
            window.qiMapProgrammaticChange = true;

            if (initialLoad) {
              // On initial load, immediately center without animation
              view.setCenter(transformedLocation);
              view.setZoom(12);
              setCurrentMapZoom(12);
            } else {
              // After initial load, smoothly animate to the new center
              view.animate({
                center: transformedLocation,
                duration: 1000, // 1 second smooth transition
              });
            }

            // Update stored center
            setCurrentMapCenter(transformedLocation);

            // Re-enable user interaction tracking after a short delay
            setTimeout(() => {
              window.qiMapProgrammaticChange = false;
            }, 1100); // Slightly longer than animation duration
          }
        }
      }
    } catch (e) {
      console.warn("Error auto-following latest point:", e);
    }
  }, [
    mapProvider,
    userHasAdjustedMap,
    initialLoad,
    selectedVehiclePlate,
    mapRef,
    trackingPoints,
    liveTrackingData,
    latestRealtimeDeviceData,
  ]);

  /* Variable Data Mapping */
  useEffect(() => {
    if (mappingData?.data?.length) {
      mappingData?.data?.map((item, id) => {
        const format = item?.section_value;
        setVariableData((prev) => ({
          ...prev,
          [`${format ? format + "." : ""}${item?.name}`]: { ...item },
        }));
        return null;
      });
      setVariablePage((prev) => prev + 1);
    }
  }, [mappingData]);

  /* Dispatch Variable Data to Global Store */
  useEffect(() => {
    if (variableData) {
      dispatch(setVariableDatas(variableData));
    }
  }, [variableData, dispatch]);

  // Helper function to handle show point on map call for all providers
  const handleShowPointOnMap = (provider) => {
    if (deviceId || selectedVehiclePlate) {
      try {
        showPontOnMap(deviceId, selectedVehiclePlate);
      } catch (e) {
        console.warn(`Error calling showPontOnMap for ${provider}:`, e);
      }
    }
  };

  function handleVehicleMarkerClick(data) {
    const uniqueId = `${data?.id}-${data?.plate_number}`;

    if (selectedRowId === uniqueId) {
      setSelectedRowId(null);
      removeLayerOnClose();
      setShowDetails(false);
      setDeviceId(null);
      setDockAlign("cross");
      setVehicleData(null);
      setselectedVehiclePlate(null);
      return;
    }

    setSelectedRowId(uniqueId);
    setShowDetails(true);
    removeLayerOnClose();
    setDeviceId(data?.device_name_list);
    setselectedVehiclePlate(data?.plate_number);
    setVehicleData(data);

    dockAlign === "cross" && setDockAlign(globalDockAlign);
    globalDockAlign === "pop-out" && addNewBox(100);
  }

  // ── Map Clustering ──
  // Clustering is active when no vehicle is selected (overview mode)
  const clusterEnabled = !selectedVehiclePlate && !deviceId;
  const validPointsForCluster = useMemo(
    () => getRenderableTrackingPoints(trackingPoints, "plate_number"),
    [trackingPoints],
  );
  const { clusterIndex, zoomVersion, onClusterClick } = useMapClustering({
    mapRef,
    mapProvider,
    trackingPoints: validPointsForCluster,
    enabled: clusterEnabled,
  });

  //Map tracking
  useEffect(() => {
    const layerName = `test_${count}`;
    const prevLayer = `test_${count - 1}`;
    const updatedTrackingPoints = getRenderableTrackingPoints(trackingPoints, "plate_number").map(
      (point) => applyCanonicalStatusToPoint(point),
    );

    if (!updatedTrackingPoints.length) removeLayerOnClose();

    if (!mapProvider || mapProvider === "qiMap") {
      if (mapRef && updatedTrackingPoints.length && !selectedVehiclePlate) {
        // Add event listeners to track user interactions (only once)
        if (mapRef && mapRef.getMapReference) {
          try {
            const olMap = mapRef.getMapReference();
            if (olMap?.on && shouldAttachMapListeners(qiMapListenerTargetRef.current, olMap)) {
              attachQiMapManualInteractionListeners(olMap, () => {
                setUserHasAdjustedMap(true);
              });

              // Update stored zoom/center on any change
              olMap.on("change:resolution", () => {
                try {
                  const view = olMap.getView();
                  if (view && view.getZoom) {
                    setCurrentMapZoom(view.getZoom());
                  }
                } catch (e) {
                  console.warn("Error tracking QI Map zoom change:", e);
                }
              });

              olMap.on("moveend", () => {
                try {
                  const view = olMap.getView();
                  if (view && view.getCenter) {
                    setCurrentMapCenter(view.getCenter());
                  }
                } catch (e) {
                  console.warn("Error tracking QI Map move:", e);
                }
              });

              qiMapListenerTargetRef.current = olMap;
            }
          } catch (e) {
            console.warn("Error adding QI Map event listeners:", e);
          }
        }

        count && mapRef.removeLayer(prevLayer);
        mapRef.addLayer({ name: layerName });

        // Store current zoom/center before redrawing if user has adjusted map
        let preserveZoom = null;
        let preserveCenter = null;
        if (userHasAdjustedMap && !initialLoad && !wasVehicleSelected) {
          try {
            const olMap = mapRef.getMapReference();
            if (olMap && olMap.getView) {
              const view = olMap.getView();
              if (view) {
                preserveZoom = view.getZoom ? view.getZoom() : currentMapZoom;
                preserveCenter = view.getCenter ? view.getCenter() : currentMapCenter;
              }
            }
          } catch (e) {
            preserveZoom = currentMapZoom;
            preserveCenter = currentMapCenter;
          }
        }

        // Compute clusters before drawing; the initial fit keeps every point in the layer.
        const shouldFitOverview =
          (initialLoad || wasVehicleSelected) && (!userHasAdjustedMap || initialLoad);
        let currentClusters = [];
        if (clusterEnabled && clusterIndex) {
          const viewport = getMapViewport(mapRef, mapProvider);
          currentClusters = viewport
            ? getVisibleClusters(clusterIndex, viewport.bbox, viewport.zoom)
            : [];
        }
        const pointsToDraw = selectOverviewPointsToDraw(
          updatedTrackingPoints,
          currentClusters,
          shouldFitOverview,
        );

        mapRef.drawTrack({
          layerName: layerName,
          fitWithinView: false,
          trackType: "point",
          data: [{ coordinates: pointsToDraw }],
          style: {
            point: {
              style: (feature) => {
                const isSelected = feature.plate_number === selectedVehiclePlate;

                const markerStyle = new Style({
                  zIndex: isSelected ? 10 : 1,
                  image: new Icon({
                    color: "#fff",
                    crossOrigin: "anonymous",
                    src: direction,
                    imgSize: [34, 40],
                    rotation: getRotation(feature.direction),
                  }),
                });

                return [markerStyle];
              },
            },
          },
        });

        // Render labels and cluster markers
        if (clusterEnabled && clusterIndex && currentClusters.length > 0) {
          const unclusteredPoints = currentClusters
            .filter((f) => !isClusterFeature(f))
            .map((f) => f.properties);
          renderQiMapLabels(mapRef, unclusteredPoints, handleVehicleMarkerClick);
          renderQiMapClusterMarkers(
            mapRef,
            currentClusters,
            clusterIndex,
            onClusterClick,
            handleVehicleMarkerClick,
          );
        } else {
          renderQiMapLabels(mapRef, updatedTrackingPoints, handleVehicleMarkerClick);
          clearQiMapClusterMarkers(mapRef);
        }

        // Only fit on initial load or when returning from vehicle selection
        if (shouldFitOverview) {
          try {
            // Mark as programmatic change
            window.qiMapProgrammaticChange = true;

            // Fit to all markers
            mapRef.performFit(layerName);

            // Store the zoom and center after fitting
            setTimeout(() => {
              const olMap = mapRef.getMapReference();
              if (olMap && olMap.getView) {
                const view = olMap.getView();
                if (view) {
                  const fittedZoom = view.getZoom ? view.getZoom() : null;
                  const overviewZoom = getOverviewFitZoom(
                    fittedZoom,
                    view.getMinZoom ? view.getMinZoom() : 0,
                  );
                  if (view.setZoom && overviewZoom !== fittedZoom) {
                    view.setZoom(overviewZoom);
                  }
                  setCurrentMapZoom(overviewZoom);
                  setCurrentMapCenter(view.getCenter ? view.getCenter() : null);
                }
              }
              window.qiMapProgrammaticChange = false;
            }, 100);

            setInitialLoad(false); // Disable initial load after first fit
            overviewFitCompletedRef.current = true;
            setWasVehicleSelected(false); // Reset after fitting
          } catch (e) {
            console.log(e);
            setInitialLoad(false);
            setWasVehicleSelected(false); // Reset even on error
          }
        } else if (preserveZoom !== null && preserveCenter !== null) {
          // Restore user's zoom and center after redrawing markers
          try {
            const olMap = mapRef.getMapReference();
            if (olMap && olMap.getView) {
              const view = olMap.getView();
              if (view && view.setZoom && view.setCenter) {
                // Mark as programmatic change
                window.qiMapProgrammaticChange = true;

                view.setZoom(preserveZoom);
                view.setCenter(preserveCenter);

                // Re-enable user interaction tracking
                setTimeout(() => {
                  window.qiMapProgrammaticChange = false;
                }, 50);
              }
            }
          } catch (e) {
            console.warn("Error restoring QI Map zoom/center:", e);
          }
        }
      } else {
        mapRef?.removeLayer(`test_${count - 1}`);
        clearQiMapLabels(mapRef);
      }
      handleShowPointOnMap("qiMap");
    } else if (
      mapRef &&
      updatedTrackingPoints.length &&
      mapProvider === "mapbox" &&
      !selectedVehiclePlate
    ) {
      const onStyleLoaded = () => {
        // Register a custom icon
        mapRef.loadImage(direction, (error, image) => {
          if (error) throw error;

          // Check if the image is already added
          if (!mapRef.hasImage("custom-icon")) {
            mapRef.addImage("custom-icon", image);
          }

          // Remove the previous layer if it exists
          if (mapRef.getLayer(layerName)) {
            mapRef.removeLayer(layerName);
            mapRef.removeSource(layerName);
          }

          // Clear previous HTML label markers
          if (window.mapboxLabelMarkers && Array.isArray(window.mapboxLabelMarkers)) {
            window.mapboxLabelMarkers.forEach((m) => m.remove());
          }
          window.mapboxLabelMarkers = [];

          // Use Mapbox native clustering
          renderMapboxClusters(
            mapRef,
            updatedTrackingPoints,
            handleVehicleMarkerClick,
            selectedVehiclePlate,
          );

          // Fit the map to the tracking points on initial load
          if (initialLoad) {
            const coordinates = updatedTrackingPoints.map((p) => [p.lng, p.lat]);
            const bounds = coordinates.reduce(
              (bounds, coord) => bounds.extend(coord),
              new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]),
            );

            mapRef.fitBounds(bounds, { padding: 50, duration: 1000 });
            setInitialLoad(false);
          }
        });
      };

      // Check if the style is already loaded
      if (mapRef && typeof mapRef.isStyleLoaded === "function" && mapRef.isStyleLoaded()) {
        onStyleLoaded();
      } else if (mapRef && typeof mapRef.on === "function") {
        // Wait for the style to load
        mapRef.on("style.load", onStyleLoaded);
      }
    } else if (
      mapProvider === "google" &&
      mapRef &&
      updatedTrackingPoints.length &&
      typeof mapRef.fitBounds === "function" &&
      !selectedVehiclePlate
    ) {
      // For Google Maps - use clustering via supercluster
      // Clear previous markers and overlays safely
      if (window.googleMarkers && Array.isArray(window.googleMarkers)) {
        window.googleMarkers.forEach((marker) => {
          try {
            if (marker && typeof marker.setMap === "function") {
              marker.setMap(null);
            }
          } catch (e) {}
        });
      }
      if (window.googleOverlays && Array.isArray(window.googleOverlays)) {
        window.googleOverlays.forEach((overlay) => {
          try {
            if (overlay && typeof overlay.setMap === "function") {
              overlay.setMap(null);
            }
          } catch (e) {}
        });
      }
      window.googleMarkers = [];
      window.googleOverlays = [];

      // Render clustered markers using supercluster data
      if (clusterEnabled && clusterIndex) {
        const viewport = getMapViewport(mapRef, "google");
        const currentClusters = viewport
          ? getVisibleClusters(clusterIndex, viewport.bbox, viewport.zoom)
          : [];
        if (currentClusters.length > 0) {
          renderGoogleMapClusters(
            mapRef,
            currentClusters,
            clusterIndex,
            handleVehicleMarkerClick,
            selectedVehiclePlate,
          );
        } else {
          updatedTrackingPoints.forEach((point) => {
            const position = { lat: point.lat, lng: point.lng };
            try {
              const marker = new google.maps.Marker({
                position,
                map: mapRef,
                icon: googleDirectionIcon(point.direction),
                zIndex: point.plate_number === selectedVehiclePlate ? 10 : 1,
              });
              marker.addListener("click", () => handleVehicleMarkerClick(point));
              window.googleMarkers.push(marker);
            } catch (e) {}
          });
        }
      } else {
        updatedTrackingPoints.forEach((point) => {
          const position = { lat: point.lat, lng: point.lng };
          try {
            const marker = new google.maps.Marker({
              position,
              map: mapRef,
              icon: googleDirectionIcon(point.direction),
              zIndex: point.plate_number === selectedVehiclePlate ? 10 : 1,
            });
            marker.addListener("click", () => handleVehicleMarkerClick(point));
            window.googleMarkers.push(marker);
          } catch (e) {}
        });
      }

      // Fit bounds on initial load
      if ((initialLoad || wasVehicleSelected) && mapRef && typeof mapRef.fitBounds === "function") {
        try {
          const bounds = new google.maps.LatLngBounds();
          updatedTrackingPoints.forEach((p) => bounds.extend({ lat: p.lat, lng: p.lng }));
          mapRef.fitBounds(bounds);
          setInitialLoad(false);
          setWasVehicleSelected(false);
        } catch (e) {
          setInitialLoad(false);
          setWasVehicleSelected(false);
        }
      }
    } else {
      handleShowPointOnMap(mapProvider);
    }
    //Increase layer count
    setCount((c) => c + 1);
  }, [
    mapRef,
    trackingPoints,
    deviceId,
    initialLoad,
    mapProvider,
    isRefreshing,
    vehicleData,
    selectedVehiclePlate,
    liveTrackingData,
    currentTab,
    wasVehicleSelected,
    mapResetCount,
    lastRefreshTime,
    applyCanonicalStatusToPoint,
    clusterIndex,
    zoomVersion,
    clusterEnabled,
  ]);
  // Show single point on map (on selection)
  function showPontOnMap(data_id, plate_number) {
    if (!mapRef || !mapProvider) return;

    let imei_info = trackingPoints.find((device_data) => device_data.plate_number === plate_number);
    let layerName = `imei-details_${selectedRow}`;

    if (mapProvider === "qiMap") {
      // Add event listeners to track user interactions (only once)
      if (mapRef && mapRef.getMapReference) {
        try {
          const olMap = mapRef.getMapReference();
          if (olMap?.on && shouldAttachMapListeners(qiMapListenerTargetRef.current, olMap)) {
            attachQiMapManualInteractionListeners(olMap, () => {
              setUserHasAdjustedMap(true);
            });

            // Update stored zoom/center on any change
            olMap.on("change:resolution", () => {
              try {
                const view = olMap.getView();
                if (view && view.getZoom) {
                  setCurrentMapZoom(view.getZoom());
                }
              } catch (e) {
                console.warn("Error tracking QI Map zoom change:", e);
              }
            });

            olMap.on("moveend", () => {
              try {
                const view = olMap.getView();
                if (view && view.getCenter) {
                  setCurrentMapCenter(view.getCenter());
                }
              } catch (e) {
                console.warn("Error tracking QI Map move:", e);
              }
            });

            qiMapListenerTargetRef.current = olMap;
          }
        } catch (e) {
          console.warn("Error adding QI Map event listeners:", e);
        }
      }

      // Store current zoom and center before clearing
      let preserveZoom = null;
      let preserveCenter = null;
      if (userHasAdjustedMap && mapRef && mapRef.getMapReference) {
        try {
          const olMap = mapRef.getMapReference();
          if (olMap && olMap.getView) {
            const view = olMap.getView();
            if (view) {
              preserveZoom = view.getZoom ? view.getZoom() : currentMapZoom;
              preserveCenter = view.getCenter ? view.getCenter() : currentMapCenter;
            }
          }
        } catch (e) {
          console.warn("Error getting QI Map current state:", e);
          preserveZoom = currentMapZoom;
          preserveCenter = currentMapCenter;
        }
      }

      // Remove previous imei-details layer
      selectedRow &&
        mapRef.removeLayerSource &&
        mapRef.removeLayerSource(`imei-details_${selectedRow - 1}`);

      // Remove all tracking points layers (test_ layers) to hide other vehicles
      for (let i = 0; i <= count; i++) {
        try {
          mapRef.removeLayer && mapRef.removeLayer(`test_${i}`);
        } catch (e) {
          // Layer might not exist, continue
        }
      }

      if (mapRef && mapRef.addLayer && mapRef.drawTrack) {
        mapRef.addLayer({ name: layerName });
        //Initial Point
        !liveTrackingData?.length &&
          mapRef.drawTrack({
            layerName: layerName,
            fitWithinView: false, // Disable auto-fit, we'll handle it manually
            trackType: "point",
            data: [{ coordinates: [imei_info] }],
            style: {
              point: {
                style: (feature) => {
                  const isSelected = feature.plate_number === selectedVehiclePlate;

                  return new Style({
                    zIndex: isSelected ? 10 : 1, // Ensure selected vehicle is on top
                    image: new Icon({
                      color: "#fff",
                      crossOrigin: "anonymous",
                      src: direction,
                      imgSize: [34, 40],
                      anchor: [0.5, 0.9],
                      rotation: getRotation(feature.direction),
                    }),
                  });
                },
              },
            },

            /* tooltip: {
              showOn: "hover",
              content: (feature) => {
                let data = feature.get("data");
                return `<div><strong>${
                  plate_number || data?.plate_number || data?.imei || ""
                }</strong></div>
              <div>${
                data?.address?.name || data?.address?.city || data?.address?.country || ""
              }</div>
              <div>${data?.speed || ""}</div>`;
              },
            }, */
          });

        // Live First Point
        liveTrackingData?.length &&
          mapRef.drawTrack({
            layerName: layerName,
            fitWithinView: false, // Disable auto-fit, we'll handle it manually
            trackType: "point",
            data: [{ coordinates: [liveTrackingData[0]] }],
            style: {
              point: {
                style: (feature) => {},
              },
            },
          });

        //Live Last Point
        liveTrackingData?.length &&
          mapRef.drawTrack({
            layerName: layerName,
            fitWithinView: false, // Disable auto-fit, we'll handle it manually
            trackType: "point",
            data: [{ coordinates: [liveTrackingData[liveTrackingData.length - 1]] }],
            style: {
              point: {
                style: (feature) => {
                  return new Style({
                    zIndex: 1,
                    image: new Icon({
                      color: "#fff",
                      crossOrigin: "anonymous",
                      src: direction,
                      imgSize: [34, 40],
                      rotation: getRotation(feature.direction),
                    }),
                  });
                },
              },
            },
          });
        //Track Line - Draw automatically when live data flows in
        liveTrackingData?.length &&
          mapRef.drawTrack({
            layerName: layerName,
            fitWithinView: false, // Disable auto-fit for updates
            trackType: "line",
            data: [{ coordinates: liveTrackingData }], // Start from initial trackpoint and include live data
            style: {
              line: {
                style: (feature) => {
                  return new Style({
                    zIndex: 0,
                    stroke: new Stroke({
                      color: "#0767d0",
                      width: 5,
                      lineDash: [5, 5],
                    }),
                  });
                },
              },
            },
          });

        // Draw directional arrows along the track line
        if (liveTrackingData?.length) {
          const arrowPoints = generateDirectionalArrowPoints(liveTrackingData, 500);
          if (arrowPoints.length > 0) {
            mapRef.drawTrack({
              layerName: layerName,
              fitWithinView: false,
              trackType: "point",
              data: [{ coordinates: arrowPoints }],
              style: {
                point: {
                  style: (feature) => {
                    const dir = feature.direction || feature.get?.("data")?.direction || 0;
                    return new Style({
                      zIndex: 2,
                      image: new Icon({
                        src: directionArrow,
                        scale: 0.6,
                        rotation: getRotation(dir + 90),
                        anchor: [0.5, 0.5],
                      }),
                    });
                  },
                },
              },
            });
          }
        }

        // Render plate number label overlay on the selected vehicle marker
        const labelPoint = liveTrackingData?.length
          ? { ...imei_info, ...liveTrackingData[liveTrackingData.length - 1] }
          : imei_info;
        if (labelPoint && labelPoint.plate_number) {
          renderQiMapLabels(
            mapRef,
            [applyCanonicalStatusToPoint(labelPoint)],
            handleVehicleMarkerClick,
          );
        }

        // Center on last location instead of fitting on initial vehicle load or when user hasn't manually adjusted the map
        if (shouldCenterOnLatestVehiclePosition(isInitialVehicleLoad, userHasAdjustedMap, mapPoint)) {
          try {
            // Determine the last location to center on
            let lastLocation = null;
            if (liveTrackingData?.length) {
              // Use the last point from live tracking data
              const lastPoint = liveTrackingData[liveTrackingData.length - 1];
              lastLocation = [lastPoint.lng, lastPoint.lat];
            } else if (imei_info) {
              // Use the initial point
              lastLocation = [imei_info.lng, imei_info.lat];
            }

            if (lastLocation && mapRef && mapRef.getMapReference) {
              const olMap = mapRef.getMapReference();
              if (olMap && olMap.getView) {
                const view = olMap.getView();
                if (view && view.setCenter && view.setZoom) {
                  // Transform coordinates from lon/lat to map projection and center
                  const transformedLocation = fromLonLat(lastLocation);

                  // Mark as programmatic change
                  window.qiMapProgrammaticChange = true;

                  view.setCenter(transformedLocation);
                  view.setZoom(19); // Set desired zoom level for last location

                  // Store the zoom and center
                  setCurrentMapZoom(19);
                  setCurrentMapCenter(transformedLocation);

                  // Re-enable user interaction tracking
                  setTimeout(() => {
                    window.qiMapProgrammaticChange = false;
                  }, 100);
                }
              }
            }

            setIsInitialVehicleLoad(false); // Mark initial load as complete
          } catch (e) {
            console.warn("Error centering QI Map on last location:", e);
            setIsInitialVehicleLoad(false); // Mark as complete even on error
          }
        } else if (
          !isInitialVehicleLoad &&
          userHasAdjustedMap &&
          preserveZoom !== null &&
          preserveCenter !== null
        ) {
          // Restore user's preferred zoom and center (only after initial load)
          try {
            const olMap = mapRef.getMapReference();
            if (olMap && olMap.getView) {
              const view = olMap.getView();
              if (view && view.setZoom && view.setCenter) {
                // Mark as programmatic change
                window.qiMapProgrammaticChange = true;

                view.setZoom(preserveZoom);
                view.setCenter(preserveCenter); // Already in map projection

                // Re-enable user interaction tracking
                setTimeout(() => {
                  window.qiMapProgrammaticChange = false;
                }, 100);
              }
            }
          } catch (e) {
            console.warn("Error restoring QI Map zoom/center:", e);
          }
        }
      }
    } else if (mapProvider === "mapbox" && mapboxAccessToken) {
      // Clear previous layers
      try {
        if (mapRef.getLayer(layerName)) {
          mapRef.removeLayer(layerName);
        }
        if (mapRef.getSource(layerName)) {
          mapRef.removeSource(layerName);
        }
        // Clear previous tracking layers
        for (let i = 0; i <= count; i++) {
          try {
            if (mapRef.getLayer(`test_${i}`)) {
              mapRef.removeLayer(`test_${i}`);
              mapRef.removeSource(`test_${i}`);
            }
          } catch (e) {
            // Layer might not exist, continue
          }
        }
      } catch (e) {
        console.warn("Error clearing mapbox layers:", e);
      }

      const onStyleLoaded = () => {
        // Load custom icons if not already loaded
        if (!mapRef.hasImage("home-icon")) {
          mapRef.loadImage(homeLocation, (error, image) => {
            if (error) console.warn("Error loading home icon:", error);
            else mapRef.addImage("home-icon", image);
          });
        }
        if (!mapRef.hasImage("direction-icon")) {
          mapRef.loadImage(direction, (error, image) => {
            if (error) console.warn("Error loading direction icon:", error);
            else mapRef.addImage("direction-icon", image);
          });
        }

        // Prepare features array
        const features = [];

        // Add initial point if no live tracking data
        if (!liveTrackingData?.length && imei_info) {
          features.push({
            type: "Feature",
            properties: {
              type: "start",
              plate_number: plate_number,
            },
            geometry: {
              type: "Point",
              coordinates: [imei_info.lng, imei_info.lat],
            },
          });
        }

        // Add live tracking points
        if (liveTrackingData?.length) {
          // Start point
          features.push({
            type: "Feature",
            properties: {
              type: "start",
              plate_number: plate_number,
            },
            geometry: {
              type: "Point",
              coordinates: [liveTrackingData[0].lng, liveTrackingData[0].lat],
            },
          });

          // End point
          const lastPoint = liveTrackingData[liveTrackingData.length - 1];
          features.push({
            type: "Feature",
            properties: {
              type: "end",
              plate_number: plate_number,
              direction: lastPoint.direction,
            },
            geometry: {
              type: "Point",
              coordinates: [lastPoint.lng, lastPoint.lat],
            },
          });

          // Track line
          features.push({
            type: "Feature",
            properties: {
              type: "line",
              plate_number: plate_number,
            },
            geometry: {
              type: "LineString",
              coordinates: liveTrackingData.map((point) => [point.lng, point.lat]),
            },
          });
        }

        // Add source
        mapRef.addSource(layerName, {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: features,
          },
        });

        // Add line layer
        mapRef.addLayer({
          id: `${layerName}-line`,
          type: "line",
          source: layerName,
          filter: ["==", ["get", "type"], "line"],
          layout: {
            "line-join": "round",
            "line-cap": "round",
          },
          paint: {
            "line-color": "#0767d0",
            "line-width": 5,
            "line-dasharray": [2, 2],
          },
        });

        // Add points layer
        mapRef.addLayer({
          id: layerName,
          type: "symbol",
          source: layerName,
          filter: ["in", ["get", "type"], ["literal", ["start", "end"]]],
          layout: {
            "icon-image": ["case", ["==", ["get", "type"], "start"], "home-icon", "direction-icon"],
            "icon-size": 0.8,
            "icon-rotate": ["case", ["==", ["get", "type"], "end"], ["get", "direction"], 0],
            "icon-rotation-alignment": "map",
            "icon-allow-overlap": true,
          },
        });

        // Fit bounds
        if (features.length > 0) {
          const coordinates = features
            .filter((f) => f.geometry.type === "Point")
            .map((f) => f.geometry.coordinates);

          if (coordinates.length > 0) {
            const bounds = coordinates.reduce(
              (bounds, coord) => bounds.extend(coord),
              new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]),
            );
            mapRef.fitBounds(bounds, { padding: 50, duration: 1000 });
          }
        }
      };

      // Check if style is loaded
      if (mapRef.isStyleLoaded()) {
        onStyleLoaded();
      } else {
        mapRef.on("style.load", onStyleLoaded);
      }
    } else if (mapProvider === "google" && googleMapsApiKey) {
      // Add event listeners to track user interactions (only once)
      if (shouldAttachMapListeners(googleMapListenerTargetRef.current, mapRef)) {
        // Listen for zoom changes
        google.maps.event.addListener(mapRef, "zoom_changed", () => {
          setUserHasAdjustedMap(true);
          setCurrentMapZoom(mapRef.getZoom());
        });

        // Listen for drag/pan events
        google.maps.event.addListener(mapRef, "dragend", () => {
          setUserHasAdjustedMap(true);
          setCurrentMapCenter(mapRef.getCenter());
        });

        googleMapListenerTargetRef.current = mapRef;
      }

      // Store current zoom and center before clearing
      const preserveZoom = userHasAdjustedMap ? currentMapZoom || mapRef?.getZoom() : null;
      const preserveCenter = userHasAdjustedMap ? currentMapCenter || mapRef?.getCenter() : null;

      // Clear previous markers and overlays
      if (window.googleSelectedMarkers && Array.isArray(window.googleSelectedMarkers)) {
        window.googleSelectedMarkers.forEach((marker) => {
          try {
            if (marker && typeof marker.setMap === "function") {
              marker.setMap(null);
            }
          } catch (e) {
            console.warn("Error clearing selected marker:", e);
          }
        });
      }
      if (window.googleSelectedOverlays && Array.isArray(window.googleSelectedOverlays)) {
        window.googleSelectedOverlays.forEach((overlay) => {
          try {
            if (overlay && typeof overlay.setMap === "function") {
              overlay.setMap(null);
            }
          } catch (e) {
            console.warn("Error clearing selected overlay:", e);
          }
        });
      }

      // Clear main tracking markers
      if (window.googleMarkers && Array.isArray(window.googleMarkers)) {
        window.googleMarkers.forEach((marker) => {
          try {
            if (marker && typeof marker.setMap === "function") {
              marker.setMap(null);
            }
          } catch (e) {
            console.warn("Error clearing marker:", e);
          }
        });
        window.googleMarkers = [];
      }
      if (window.googleOverlays && Array.isArray(window.googleOverlays)) {
        window.googleOverlays.forEach((overlay) => {
          try {
            if (overlay && typeof overlay.setMap === "function") {
              overlay.setMap(null);
            }
          } catch (e) {
            console.warn("Error clearing overlay:", e);
          }
        });
        window.googleOverlays = [];
      }

      // Initialize arrays
      window.googleSelectedMarkers = [];
      window.googleSelectedOverlays = [];
      const bounds = new google.maps.LatLngBounds();

      // Add initial point if no live tracking data
      if (!liveTrackingData?.length && imei_info) {
        const position = { lat: imei_info.lat, lng: imei_info.lng };

        const marker = new google.maps.Marker({
          position,
          map: mapRef,
          icon: googleDirectionIcon(imei_info.direction, 32),
          zIndex: 10,
        });

        bounds.extend(position);
        window.googleSelectedMarkers.push(marker);
      }

      // Add live tracking points and line
      if (liveTrackingData?.length) {
        // Start point
        // const startPosition = { lat: liveTrackingData[0].lat, lng: liveTrackingData[0].lng };
        // const startMarker = new google.maps.Marker({
        //   position: startPosition,
        //   map: mapRef,
        //   icon: {
        //     url: homeLocation,
        //     scaledSize: new google.maps.Size(32, 32),
        //   },
        //   zIndex: 10,
        // });
        // window.googleSelectedMarkers.push(startMarker);
        // bounds.extend(startPosition);

        // End point
        const lastPoint = liveTrackingData[liveTrackingData.length - 1];
        const endPosition = { lat: lastPoint.lat, lng: lastPoint.lng };
        const endMarker = new google.maps.Marker({
          position: endPosition,
          map: mapRef,
          icon: googleDirectionIcon(lastPoint.direction, 32),
          zIndex: 10,
        });
        window.googleSelectedMarkers.push(endMarker);
        bounds.extend(endPosition);

        // Track line
        const path = liveTrackingData.map((point) => ({ lat: point.lat, lng: point.lng }));
        const polyline = new google.maps.Polyline({
          path: path,
          geodesic: true,
          strokeColor: "#0767d0",
          strokeOpacity: 1.0,
          strokeWeight: 5,
          strokeDashArray: "10,5",
          icons: [
            {
              icon: {
                path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                scale: 2.5,
                strokeColor: "#ffffff",
                strokeOpacity: 0.8,
                strokeWeight: 1,
                fillColor: "#ffffff",
                fillOpacity: 0.6,
              },
              offset: "0",
              repeat: "100px",
            },
          ],
        });
        polyline.setMap(mapRef);
        window.googleSelectedOverlays.push(polyline);
      }

      // Auto-fit bounds on initial vehicle load or when user hasn't manually adjusted the map
      if (
        window.googleSelectedMarkers.length > 0 &&
        (isInitialVehicleLoad || !userHasAdjustedMap)
      ) {
        try {
          mapRef.fitBounds(bounds);
          // Store the initial zoom and center after fitBounds
          setTimeout(() => {
            setCurrentMapZoom(mapRef.getZoom());
            setCurrentMapCenter(mapRef.getCenter());
            setIsInitialVehicleLoad(false); // Mark initial load as complete
          }, 100);
        } catch (e) {
          console.warn("Error fitting bounds:", e);
          setIsInitialVehicleLoad(false); // Mark as complete even on error
        }
      } else if (
        !isInitialVehicleLoad &&
        userHasAdjustedMap &&
        preserveZoom !== null &&
        preserveCenter !== null
      ) {
        // Restore user's preferred zoom and center (only after initial load)
        try {
          mapRef.setZoom(preserveZoom);
          mapRef.setCenter(preserveCenter);
        } catch (e) {
          console.warn("Error restoring zoom/center:", e);
        }
      }
    }

    setSelectedRow((i) => i + 1);
  }

  const removeLayerOnClose = () => {
    try {
      if (mapProvider === "mapbox") {
        // Helper function to remove a Mapbox layer and its source
        const removeLayerAndSource = (id) => {
          if (trackMapRef && trackMapRef.getLayer && trackMapRef.getLayer(id)) {
            trackMapRef.removeLayer(id);
          }
          if (trackMapRef && trackMapRef.getSource && trackMapRef.getSource(id)) {
            trackMapRef.removeSource(id);
          }
        };

        // Remove layers and sources specific to Mapbox
        if (mapRef) {
          removeLayerAndSource(`imei-details_${selectedRow - 1}`);
        }
        if (trackMapRef) {
          removeLayerAndSource(`track_${deviceId}`);
        }

        // Clear HTML label markers
        if (window.mapboxLabelMarkers && Array.isArray(window.mapboxLabelMarkers)) {
          window.mapboxLabelMarkers.forEach((m) => m.remove());
          window.mapboxLabelMarkers = [];
        }
      } else if (mapProvider === "google") {
        // Clear all overlays (markers, polylines) specific to Google Maps
        const removeGoogleOverlays = (prefix) => {
          for (let i = 0; i < count; i++) {
            const overlayGroup = window[`${prefix}_${i}_google`];
            if (overlayGroup && Array.isArray(overlayGroup)) {
              overlayGroup.forEach((overlay) => {
                try {
                  if (overlay && typeof overlay.setMap === "function") {
                    overlay.setMap(null);
                  }
                } catch (e) {
                  console.warn("Error removing overlay:", e);
                }
              });
              window[`${prefix}_${i}_google`] = null; // Clear reference
            }
          }
        };

        // Clear current markers and overlays safely
        if (window.googleMarkers && Array.isArray(window.googleMarkers)) {
          window.googleMarkers.forEach((marker) => {
            try {
              if (marker && typeof marker.setMap === "function") {
                marker.setMap(null);
              }
            } catch (e) {
              console.warn("Error removing marker:", e);
            }
          });
          window.googleMarkers = [];
        }
        if (window.googleOverlays && Array.isArray(window.googleOverlays)) {
          window.googleOverlays.forEach((overlay) => {
            try {
              if (overlay && typeof overlay.setMap === "function") {
                overlay.setMap(null);
              }
            } catch (e) {
              console.warn("Error removing overlay:", e);
            }
          });
          window.googleOverlays = [];
        }

        // Clear selected markers and overlays (for vehicle selection)
        if (window.googleSelectedMarkers && Array.isArray(window.googleSelectedMarkers)) {
          window.googleSelectedMarkers.forEach((marker) => {
            try {
              if (marker && typeof marker.setMap === "function") {
                marker.setMap(null);
              }
            } catch (e) {
              console.warn("Error removing selected marker:", e);
            }
          });
          window.googleSelectedMarkers = [];
        }
        if (window.googleSelectedOverlays && Array.isArray(window.googleSelectedOverlays)) {
          window.googleSelectedOverlays.forEach((overlay) => {
            try {
              if (overlay && typeof overlay.setMap === "function") {
                overlay.setMap(null);
              }
            } catch (e) {
              console.warn("Error removing selected overlay:", e);
            }
          });
          window.googleSelectedOverlays = [];
        }

        // Remove Google-specific overlays
        if (mapRef) {
          removeGoogleOverlays(`imei-details`);
        }
        if (trackMapRef) {
          removeGoogleOverlays(`track`);
        }
      } else if (mapProvider === "qiMap") {
        // Specific handling for `qiMap`
        mapRef &&
          mapRef.removeLayerSource &&
          mapRef.removeLayerSource(`imei-details_${selectedRow - 1}`);
        trackMapRef &&
          trackMapRef.removeLayerSource &&
          trackMapRef.removeLayerSource(`track_${deviceId}`);
      }
    } catch (error) {
      console.error("Error removing layers or overlays:", error);
    }
  };

  const removeRowSelection = () => {
    setHighlight(null);
    setSelectedRowId(null);
  };

  const { activeBoxes, addNewBox, removeBox, revertBox, isItemsDragging, handleDragChange } =
    useDndContainer();

  const handleCloseVehiclePopout = (id) => {
    closeVehiclePopout(id, {
      removeBox,
      removeLayerOnClose,
      setShowDetails,
      removeRowSelection,
      setDeviceId,
      setSelectedVehiclePlate: setselectedVehiclePlate,
      setVehicleData,
      setShowTrack,
      setDockAlign,
      setCurrentTab,
    });
  };

  //Reset Map to Initial State
  const resetMapToInitialState = useCallback(() => {
    setMapResetCount((count) => count + 1);
    setMapPoint({});
    setSelectedTrackPointData(null);
    setUserHasAdjustedMap(false);
    setCurrentMapZoom(null);
    setCurrentMapCenter(null);
    setInitialLoad(true);
    setWasVehicleSelected(false);
  }, []);

  useEffect(() => {
    // Wait for the matching query so the fit includes the new results, not the previous data.
    if (
      previousSearchRef.current !== simpleSearch &&
      currentTrackingData &&
      (!sortedDataDisplay || q === simpleSearch)
    ) {
      previousSearchRef.current = simpleSearch;
      resetMapToInitialState();
    }
  }, [simpleSearch, q, sortedDataDisplay, currentTrackingData, resetMapToInitialState]);

  useEffect(() => {
    if (isTrackPointsHistoryDataCollected && !selectedVehiclePlate) {
      resetMapToInitialState();
    }
  }, [isTrackPointsHistoryDataCollected, selectedVehiclePlate]);

  //Show Map
  const showMap = () => {
    setCurrentTab("Map");
    setShowTrack(false);
    if (!selectedVehiclePlate) resetMapToInitialState();
  };

  //Show Live Track
  const showLiveTrack = () => {
    setMapRef(null);
    setCurrentTab("LiveTrack");
    setShowTrack(true);
  };

  //Show Activities
  const showActivities = () => {
    setCurrentTab("Activities");
    setShowTrack(true);
  };

  //Show Trips
  const showTrips = () => {
    setCurrentTab("Trips");
    setShowTrack(true);
  };

  //Show Events
  const showEvents = () => {
    setCurrentTab("Events");
    setShowTrack(true);
  };

  //Show Raw Data
  const showRawData = () => {
    setCurrentTab("RawData");
    setShowTrack(true);
  };

  //Show Graphs
  const showGraphs = () => {
    setCurrentTab("Graphs");
    setShowTrack(true);
  };

  //Show Trackpoints
  const showTrackpoints = () => {
    setCurrentTab("TrackPoints");
    setShowTrack(true);
  };

  //clear live track on type
  useEffect(() => {
    if (simpleSearch) {
      setShowTrack(false);
      setShowDetails(false);
      setSelectedRowId(null);
      setselectedVehiclePlate(null);
      setVehicleData(null);
      setCurrentTab("Map");
      setDeviceId(null);
      setDockAlign("cross");
      setHighlight(null);
      removeLayerOnClose();
    }
  }, [simpleSearch]);

  //Hide Vehicle Details for Track Points
  useEffect(() => {
    if (currentTab !== "Reports") {
      selectedVehiclePlate && setShowDetails(true);
    }
  }, [selectedVehiclePlate, currentTab]);

  const [activitiesTimeRange, setActivitiesTimeRange] = useState(selectedRange);
  const [refreshMap, setRefreshMap] = useState(false);
  const [mapSelectionLoading, setMapSelectionLoading] = useState(false);

  //To set the total count of data in the list of activity and trips
  const [listCount, setListCount] = useState(0);

  useEffect(() => {
    setRefreshMap((prev) => !prev);
    setListCount(0);
  }, [selectedRange, currentTab]);

  // Keep activitiesTimeRange in sync with UI range on tab switch to Activities/Trips
  useEffect(() => {
    if (currentTab === "Activities" || currentTab === "Trips") {
      const curStart = activitiesTimeRange?.startDate || activitiesTimeRange?.start_time;
      const curEnd = activitiesTimeRange?.endDate || activitiesTimeRange?.end_time;
      const uiStart = selectedRange?.startDate;
      const uiEnd = selectedRange?.endDate;

      const sameStart = curStart && uiStart && moment(curStart).isSame(moment(uiStart));
      const sameEnd = curEnd && uiEnd && moment(curEnd).isSame(moment(uiEnd));

      if (!sameStart || !sameEnd) {
        setActivitiesTimeRange(selectedRange);
      }
    }
  }, [currentTab, selectedRange]);

  // Add these new hooks
  const { page, perPage } = usePagination();

  const { data = { data: [], total_count: 0 } } = useGetPluginsQuery({
    page,
    per_page: perPage,
    order_by: "plugins.created_at",
    order_dir: "desc",
  });

  const addPlugins = data.data.filter(
    (plugin) =>
      plugin.tracker_containers.map((s) => parseInt(s, 10)).includes(1) && plugin.is_enabled,
  );
  const isPluginTab = addPlugins.some((plugin) => plugin.name === currentTab);
  const selectedPlugin = data.data.find((plugin) => plugin.name === currentTab);

  // Add this new function
  const showdetailsTabs = (tab) => {
    setShowDetails(false);
    setDockAlign("cross");
    setCurrentTab(tab);
  };

  useEffect(() => {
    if (currentTab) {
      dispatch(setCurrentTabGlobal(currentTab));
    }
  }, [currentTab]);

  useEffect(() => {
    dispatch(setGlobalResetCount(globalResetCount + 1));
  }, [selectedVehiclePlate, currentTab]);

  useEffect(() => {
    if (currentTab !== "Map" && !selectedVehiclePlate) {
      setCurrentTab("Map");
    }
  }, [currentTab, selectedVehiclePlate]);

  // Track whether the live range has been properly initialized for the current vehicle.
  // This prevents LiveTrackPoints from firing an API call with the stale (previous) range
  // before the new range is set, which was the root cause of duplicate API requests with
  // different start/end times.
  const [liveRangeReady, setLiveRangeReady] = useState(false);
  // Track which vehicle the current selectedRangeLive was computed for.
  // This allows LiveTrackPoints to skip the query if selectedRangeLive still belongs
  // to a previous vehicle (stale state).
  const liveRangeVehicleRef = useRef(null);

  // Clear the Live data when deviceId changes
  useEffect(() => {
    // Check if we're transitioning from selected to deselected
    const wasSelected = prevSelectedVehiclePlateRef.current;
    const isNowDeselected = wasSelected && !selectedVehiclePlate;
    const isNewVehicleSelected = selectedVehiclePlate && selectedVehiclePlate !== wasSelected;

    // Mark the live range as NOT ready before updating it.
    // This ensures LiveTrackPoints skips the query until the new range is applied.
    setLiveRangeReady(false);
    liveRangeVehicleRef.current = selectedVehiclePlate;

    setLiveTrackingData([]);
    setTrackpointsHistoryData([]);
    setLiveRoutePoints([]);
    dispatch(setLiveTrackData([]));

    const now = moment();
    setSelectedRangeLive({
      startDate: moment(now).subtract(trackpointsSelectedRange, "minutes"),
      endDate: now,
    });

    setIsTrackPointsHistoryDataCollected(false);

    // Only reset map adjustment tracking when selecting a NEW vehicle or deselecting
    // Don't reset when just switching tabs with the same vehicle
    if (isNewVehicleSelected || isNowDeselected) {
      setUserHasAdjustedMap(false);
      setCurrentMapZoom(null);
      setCurrentMapCenter(null);
      setIsInitialVehicleLoad(true);
    }

    // Track if we're transitioning from selected to deselected (for bounds fitting)
    setWasVehicleSelected(isNowDeselected);
    // Update ref for next comparison
    prevSelectedVehiclePlateRef.current = selectedVehiclePlate;
  }, [selectedVehiclePlate]);

  // Mark live range as ready AFTER selectedRangeLive has been applied.
  // This runs in the render cycle AFTER setSelectedRangeLive, ensuring the component
  // tree receives the fresh range before the query is allowed to fire.
  useEffect(() => {
    if (selectedVehiclePlate && !liveRangeReady) {
      setLiveRangeReady(true);
    }
  }, [selectedRangeLive, selectedVehiclePlate]);

  // Clear map when no vehicle is selected
  useEffect(() => {
    if (!selectedVehiclePlate && !deviceId) {
      removeLayerOnClose();
    }
  }, [selectedVehiclePlate, deviceId]);

  useEffect(() => {
    if (selectedVehiclePlate) {
      setLiveTime(
        moment().subtract(trackpointsSelectedRange, "minutes").format("DD/MM/YY - hh:mm:ss A"),
      );
    }
  }, [selectedVehiclePlate]);

  return (
    <>
      <main className={`tracking-app-main-container item-list-right-layout`}>
        <article className={`tracking-app-main-container_block ${currentTab}`}>
          <VehicleList
            setDetails={setShowDetails}
            setDeviceId={setDeviceId}
            setSourceIds={setSourceIds}
            showPontOnMap={showPontOnMap}
            mapData={mapData}
            setselectedVehiclePlate={setselectedVehiclePlate}
            setHighlight={setHighlight}
            highlight={highlight}
            dockAlign={dockAlign}
            setDockAlign={setDockAlign}
            setShowDetails={setShowDetails}
            removeLayerOnClose={removeLayerOnClose}
            mapExpand={mapExpand}
            setMapExpand={setMapExpand}
            trackMapRef={trackMapRef}
            deviceId={deviceId}
            setShowTrack={setShowTrack}
            setSimpleSearch={setSimpleSearch}
            simpleSearch={simpleSearch}
            currentTab={currentTab}
            removeRowSelection={removeRowSelection}
            selectedRowId={selectedRowId}
            setSelectedRowId={setSelectedRowId}
            vehicleData={vehicleData}
            setVehicleData={setVehicleData}
            setCurrentTab={setCurrentTab}
            vehiclesData={sortedDataDisplay && vehiclesData}
            totalCountVehicles={sortedDataDisplay && trackingData?.total_count}
            paginationVehicles={sortedDataDisplay && pagination}
            setPageVehicles={setPage1}
            sortedDataDisplay={sortedDataDisplay}
            setSortedDataDisplay={setSortedDataDisplay}
            plateSort={plateSort}
            setPlateSort={setPlateSort}
            q={q}
            setNonAdminUserId={setNonAdminUserId}
            nonAdminUserId={nonAdminUserId}
            addNewBox={addNewBox}
            isRefreshing={isRefreshing}
            telemetry={canonicalTelemetry}
          />
          <div className="map-and-tabs-container">
            <header className="tracking-app-main-container_block_header">
              <HorizontalScroll className="map-view-tabs">
                {(deviceId || selectedVehiclePlate) && (
                  <ul className="map-and-details_tabs">
                    <li>
                      <span
                        className={`map-and-details_tabs_item ${currentTab === "Map" && "active"}`}
                        onClick={showMap}
                      >
                        {getLocalizedString("live", "Live")}
                        <LiveStatusIndicator
                          data={vehiclesData.find((vehicle) => vehicle.plate_number === selectedVehiclePlate)}
                          plateNumber={selectedVehiclePlate}
                          telemetry={canonicalTelemetry}
                        />
                      </span>
                    </li>
                    {selectedRowId !== null && (
                      <li>
                        <span
                          className={`map-and-details_tabs_item ${
                            currentTab === "LiveTrack" && "active"
                          }`}
                          onClick={
                            () =>
                              deviceId /*  && deviceId !== "N/A" */
                                ? showLiveTrack()
                                : null /* toast.error(
                                getLocalizedString("no_device_selected", "No Device Selected")
                              ) */
                          }
                        >
                          {getLocalizedString("history", "History")}
                        </span>
                      </li>
                    )}
                    {selectedRowId !== null && (
                      <li>
                        <span
                          className={`map-and-details_tabs_item ${
                            currentTab === "Activities" && "active"
                          }`}
                          onClick={
                            () =>
                              deviceId /* && deviceId !== "N/A" */
                                ? showActivities()
                                : null /* toast.error(
                                getLocalizedString("no_device_selected", "No Device Selected")
                              ) */
                          }
                        >
                          {getLocalizedString("activities", "Activities")}
                        </span>
                      </li>
                    )}
                    {selectedRowId !== null && (
                      <li>
                        <span
                          className={`map-and-details_tabs_item ${
                            currentTab === "Trips" && "active"
                          }`}
                          onClick={
                            () =>
                              deviceId /* && deviceId !== "N/A" */
                                ? showTrips()
                                : null /* toast.error(
                                getLocalizedString("no_device_selected", "No Device Selected")
                              ) */
                          }
                        >
                          {getLocalizedString("trips", "Trips")}
                        </span>
                      </li>
                    )}
                    {selectedRowId !== null && (
                      <li>
                        <span
                          className={`map-and-details_tabs_item ${
                            currentTab === "Events" && "active"
                          }`}
                          onClick={
                            () =>
                              deviceId /* && deviceId !== "N/A" */
                                ? showEvents()
                                : null /* toast.error(
                                getLocalizedString("no_device_selected", "No Device Selected")
                              ) */
                          }
                        >
                          {getLocalizedString("events", "Events")}
                        </span>
                      </li>
                    )}
                    {selectedRowId !== null && (
                      <li>
                        <span
                          className={`map-and-details_tabs_item ${
                            currentTab === "RawData" && "active"
                          }`}
                          onClick={
                            () =>
                              deviceId /* && deviceId !== "N/A" */
                                ? showRawData()
                                : null /* toast.error(
                                getLocalizedString("no_device_selected", "No Device Selected")
                              ) */
                          }
                        >
                          {getLocalizedString("raw_data", "Raw Data")}
                        </span>
                      </li>
                    )}
                    {selectedRowId !== null && (
                      <li>
                        <span
                          className={`map-and-details_tabs_item ${
                            currentTab === "Graphs" && "active"
                          }`}
                          onClick={
                            () =>
                              deviceId /* && deviceId !== "N/A" */
                                ? showGraphs()
                                : null /* toast.error(
                                getLocalizedString("no_device_selected", "No Device Selected")
                              ) */
                          }
                        >
                          {getLocalizedString("graphs", "Graphs")}
                        </span>
                      </li>
                    )}
                    {addPlugins &&
                      addPlugins.map((plugin, index) => (
                        <li key={index}>
                          <span
                            className={`map-and-details_tabs_item ${
                              currentTab === plugin.name && "active"
                            }`}
                            onClick={() => showdetailsTabs(plugin.name)}
                          >
                            {getLocalizedString("plugins", plugin.name)}
                          </span>
                        </li>
                      ))}
                  </ul>
                )}
              </HorizontalScroll>

              {currentTab === "Map" && selectedVehiclePlate && (
                <span className="trackpoints-selected-range">
                  <strong>
                    {getLocalizedString("since", "Since")} {liveTime}
                  </strong>
                </span>
              )}

              <QIAutoMapIndicator
                currentTab={currentTab}
                mapProvider={mapProvider}
                dataId={selectedVehiclePlate}
                trackingPoints={trackingPoints}
                userHasAdjustedMap={userHasAdjustedMap || Boolean(mapPoint?.is_valid && mapPoint?.lat && mapPoint?.lng)}
                resetMapToInitialState={resetMapToInitialState}
              />

              {/* Date Range Picker and Column Config Setting */}
              {(currentTab == "LiveTrack" || currentTab == "Map") && (
                <QICustomDateRangePicker
                  resetCount={resetCount}
                  selectedRange={selectedRangeHistory}
                  setSelectedRangeLocal={setSelectedRangeHistory}
                  localRange={true}
                  setResetCount={setResetCount}
                  openCalendar="left"
                  className={currentTab == "Map" ? "live" : ""}
                />
              )}

              {/* Date Range Picker for Trips Events Activities and Raw Data with 24 hrs default value*/}
              {(currentTab == "Trips" ||
                currentTab == "Activities" ||
                currentTab == "Events" ||
                currentTab == "RawData") && (
                <QICustomDateRangePicker
                  resetCount={globalResetCount}
                  selectedRange={selectedRange}
                  openCalendar="left"
                  preventAutoUpdate={true}
                />
              )}
            </header>
            <article
              className={`map-and-details ${dockAlign} ${
                maximizeMinimize ? "minimized-details" : ""
              }`}
            >
              {currentTab === "Map" ? (
                <VehicleMap
                  mapExpand={mapExpand}
                  mapRef={mapRef}
                  dockAlign={dockAlign}
                  setMapRef={setMapRef}
                  deviceId={deviceId}
                  selectedRowId={selectedRowId}
                  maximizeMinimize={maximizeMinimize}
                  mapProvider={mapProvider}
                  mapboxAccessToken={mapboxAccessToken}
                  googleMapsApiKey={googleMapsApiKey}
                  selectedVehiclePlate={selectedVehiclePlate}
                  currentMapCenter={currentMapCenter}
                  currentMapZoom={currentMapZoom}
                  userHasAdjustedMap={userHasAdjustedMap}
                  mapPoint={mapPoint}
                  resetMapToInitialState={resetMapToInitialState}
                  statusData={vehiclesData}
                  showStatusCounts={!showDetails}
                />
              ) : currentTab === "LiveTrack" ? (
                <VehicleTrack
                  dockAlign={dockAlign}
                  deviceId={deviceId}
                  realTimeData={realTimedata[selectedVehiclePlate]}
                  setTrackMapRef={setTrackMapRef}
                  trackMapRef={trackMapRef}
                  mapExpand={mapExpand}
                  selectedRange={selectedRangeHistory}
                  setResetCount={setResetCount}
                  maximizeMinimize={maximizeMinimize}
                  mapProvider={mapProvider}
                  selectedVehiclePlate={selectedVehiclePlate}
                  showTooltip={true}
                  type="Vehicles"
                  clientConfig={clientConfig}
                  trackingPoints={trackingPoints}
                  mapPoint={mapPoint}
                  mapboxAccessToken={mapboxAccessToken}
                  googleMapsApiKey={googleMapsApiKey}
                />
              ) : currentTab === "TrackPoints" ? (
                <EventsMap
                  dockAlign={dockAlign}
                  mapExpand={mapExpand}
                  deviceId={deviceId}
                  mapPoint={mapPoint}
                  selectedRowId={deviceId}
                  setDockAlign={setDockAlign}
                  maximizeMinimize={maximizeMinimize}
                  refreshMap={refreshMap}
                  mapProvider={mapProvider}
                  mapboxAccessToken={mapboxAccessToken}
                  googleMapsApiKey={googleMapsApiKey}
                  showEventsDetails={showEventsDetails}
                />
              ) : currentTab === "Activities" ? (
                <TripsMap
                  dockAlign={dockAlign}
                  mapExpand={mapExpand}
                  deviceId={deviceId}
                  selectedRange={activitiesTimeRange}
                  maximizeMinimize={maximizeMinimize}
                  refreshMap={refreshMap}
                  mapProvider={mapProvider}
                  mapboxAccessToken={mapboxAccessToken}
                  googleMapsApiKey={googleMapsApiKey}
                  listCount={listCount}
                  clientConfig={clientConfig}
                  mapSelectionLoading={mapSelectionLoading}
                />
              ) : currentTab === "Trips" ? (
                <TripsMap
                  dockAlign={dockAlign}
                  mapExpand={mapExpand}
                  deviceId={deviceId}
                  selectedRange={activitiesTimeRange}
                  maximizeMinimize={maximizeMinimize}
                  refreshMap={refreshMap}
                  mapProvider={mapProvider}
                  listCount={listCount}
                  mapboxAccessToken={mapboxAccessToken}
                  googleMapsApiKey={googleMapsApiKey}
                  clientConfig={clientConfig}
                  mapSelectionLoading={mapSelectionLoading}
                />
              ) : currentTab === "Events" ? (
                <EventsMap
                  dockAlign={dockAlign}
                  mapExpand={mapExpand}
                  deviceId={deviceId}
                  mapPoint={mapPoint}
                  selectedRowId={deviceId}
                  setDockAlign={setDockAlign}
                  maximizeMinimize={maximizeMinimize}
                  refreshMap={refreshMap}
                  mapProvider={mapProvider}
                  mapboxAccessToken={mapboxAccessToken}
                  googleMapsApiKey={googleMapsApiKey}
                  showEventsDetails={showEventsDetails}
                />
              ) : isPluginTab ? (
                <PluginContainer selectedPlugin={selectedPlugin} />
              ) : null}

              {/* Details Block  */}

              {showDetails === true && currentTab !== "RawData" && currentTab !== "Graphs" && (
                <article className={`details-block`}>
                  <QIDragAndDropDetails
                    setDetails={setShowDetails}
                    setPopup={openDeviceModal}
                    setCurrentTab={setCurrentTab}
                    deviceData={deviceData || {}}
                    removeLayerOnClose={removeLayerOnClose}
                    selectedVehiclePlate={selectedVehiclePlate}
                    setSelectedVehiclePlate={setselectedVehiclePlate}
                    removeRowSelection={removeRowSelection}
                    setDockAlign={setDockAlign}
                    dockAlign={dockAlign}
                    deviceId={deviceId}
                    realTimedata={realTimedata}
                    type="Vehicles"
                    setDeviceId={setDeviceId}
                    showTrack={showTrack}
                    setShowTrack={setShowTrack}
                    headerName={getLocalizedString("vehicle_plate_number", "Vehicle Plate Number")}
                    headerDetails={
                      <HeaderDetails
                        realTimedata={realTimedata}
                        deviceData={deviceData}
                        deviceId={deviceId}
                        selectedVehiclePlate={selectedVehiclePlate}
                        telemetry={canonicalTelemetry}
                        type="Vehicles"
                      />
                    }
                    listDetails={
                      <ListDetails
                        clientConfig={clientConfig}
                        realTimedata={realTimedata}
                        deviceData={deviceData}
                        deviceId={deviceId}
                        currentTab={currentTab}
                        selectedVehiclePlate={selectedVehiclePlate}
                        type="Vehicles"
                      />
                    }
                    currentTab={currentTab}
                    maximizeMinimize={maximizeMinimize}
                    setmaximizeMinimize={setmaximizeMinimize}
                    liveDetailsBlockView={liveDetailsBlockView}
                    setLiveDetailsBlockView={setLiveDetailsBlockView}
                    customContent={
                      currentTab === "Activities" ||
                      currentTab === "Trips" ||
                      currentTab === "Events" ||
                      currentTab === "TrackPoints" ||
                      currentTab === "LiveTrack" ||
                      currentTab === "Graphs" ||
                      (currentTab === "Map" && liveDetailsBlockView === "TrackPoints")
                        ? true
                        : false
                    }
                  >
                    {(currentTab === "Activities" ||
                      currentTab === "Trips" ||
                      currentTab === "Events") &&
                      selectedVehiclePlate && (
                        <SelectedAssetSummary
                          plateNumber={selectedVehiclePlate}
                          cardType="Vehicles"
                          variant="plate"
                        />
                      )}
                    {currentTab === "Activities" && (
                      <Activities
                        deviceId={deviceId}
                        selectedRange={selectedRange}
                        clientId={clientId}
                        selectedVehiclePlate={selectedVehiclePlate}
                        type="Vehicles"
                        setActivitiesTimeRange={setActivitiesTimeRange}
                        setListCount={setListCount}
                      />
                    )}
                    {currentTab === "Trips" && (
                      <TripsContainer
                        resetCount={globalResetCount}
                        setResetCount={setGlobalResetCount}
                        deviceId={deviceId}
                        selectedRange={selectedRange}
                        setSelectedRange={setSelectedRangeHistory}
                        clientId={clientId}
                        selectedVehiclePlate={selectedVehiclePlate}
                        type="Vehicles"
                        setActivitiesTimeRange={setActivitiesTimeRange}
                        setListCount={setListCount}
                        setMapSelectionLoading={setMapSelectionLoading}
                      />
                    )}
                    {currentTab === "Events" && (
                      <EventsContainer
                        resetCount={globalResetCount}
                        setResetCount={setGlobalResetCount}
                        deviceId={deviceId}
                        selectedRange={selectedRange}
                        setSelectedRange={setSelectedRangeHistory}
                        clientId={clientId}
                        selectedVehiclePlate={selectedVehiclePlate}
                        type="Vehicles"
                        setDeviceId={setDeviceId}
                        setDockAlign={setDockAlign}
                        setMapPoint={setMapPoint}
                        setShowEventsDetails={setShowEventsDetails}
                      />
                    )}
                    {currentTab === "Graphs" && (
                      <GraphsContainer
                        deviceId={deviceId}
                        selectedVehiclePlate={selectedVehiclePlate}
                        type="Vehicles"
                      />
                    )}

                    {currentTab === "Map" && (
                      <>
                        <LiveTrackPoints
                          deviceId={deviceId}
                          setDeviceId={setDeviceId}
                          liveData={realTimedata}
                          onRoutePackets={handleRoutePackets}
                          telemetry={canonicalTelemetry}
                          selectedVehiclePlate={selectedVehiclePlate}
                          selectedRange={selectedRangeLive}
                          setResetCount={setResetCount}
                          setMapPoint={setMapPoint}
                          clearSelectionKey={mapResetCount}
                          setDockAlign={setDockAlign}
                          type="Vehicles"
                          currentTab={currentTab}
                          setSelectedTrackPointData={setSelectedTrackPointData}
                          setLiveDetailsBlockView={setLiveDetailsBlockView}
                          deviceData={deviceData}
                          setTrackpointsHistoryData={setLiveRoutePoints}
                          setIsTrackPointsHistoryDataCollected={
                            setIsTrackPointsHistoryDataCollected
                          }
                          skipQuery={!liveRangeReady}
                          selectedAsset={vehicleData}
                          mapData={mapData}
                          summaryCardType="Vehicles"
                        />
                      </>
                    )}
                    {currentTab === "LiveTrack" && (
                      <>
                        <HistoryTrackPoints
                          deviceId={deviceId}
                          setDeviceId={setDeviceId}
                          liveData={realTimedata}
                          selectedVehiclePlate={selectedVehiclePlate}
                          selectedRange={selectedRangeHistory}
                          setResetCount={setResetCount}
                          setMapPoint={setMapPoint}
                          setDockAlign={setDockAlign}
                          type="Vehicles"
                          currentTab={currentTab}
                          setSelectedTrackPointData={setSelectedTrackPointData}
                          setLiveDetailsBlockView={setLiveDetailsBlockView}
                          deviceData={deviceData}
                          setTrackpointsHistoryData={setTrackpointsHistoryData}
                          telemetry={canonicalTelemetry}
                          selectedAsset={vehicleData}
                          mapData={mapData}
                          summaryCardType="Vehicles"
                        />
                      </>
                    )}
                  </QIDragAndDropDetails>
                </article>
              )}

              {/* Details Block End */}
            </article>
            {currentTab === "Graphs" && (
              <GraphsContainer
                deviceId={deviceId}
                selectedVehiclePlate={selectedVehiclePlate}
                type="Vehicles"
              />
            )}
            {currentTab === "RawData" && (
              <>
                <section className="tracking-app-main-container_block_header_secondary has-plate-summary">
                  {selectedVehiclePlate && (
                    <SelectedAssetSummary
                      plateNumber={selectedVehiclePlate}
                      cardType="Vehicles"
                      variant="plate"
                    />
                  )}
                  {/* Date Range Picker and Column Config Setting */}
                  <div className="raw-data-section">
                    <>
                      <QISwitch
                        label="Decode"
                        value={decode}
                        onChange={(value) => {
                          setDecode((prev) => !prev);
                        }}
                        title={
                          decode
                            ? getLocalizedString(
                                "data_will_be_blank_if_format_is_binary",
                                "Data will be blank if format is binary",
                              )
                            : getLocalizedString(
                                "data_will_be_displayed_in_base64encoded_format",
                                "Data will be displayed in base64encoded format",
                              )
                        }
                        disabled={false}
                        readOnly={false}
                      />

                      <QISwitch
                        label={order ? "Asec" : "Desc"}
                        value={order}
                        onChange={(value) => {
                          setOrder((prev) => !prev);
                        }}
                        title={""}
                        disabled={false}
                        readOnly={false}
                      />
                    </>
                  </div>
                </section>
                <RawData
                  deviceId={deviceId}
                  selectedRange={selectedRange}
                  decode={decode}
                  order={order}
                />
              </>
            )}
          </div>
        </article>
      </main>

      {dockAlign === "pop-out" && (
        <Dnd
          layoutName="trackingLayout"
          isItemsDragging={isItemsDragging}
          handleDragChange={handleDragChange}
          setDetails={setShowDetails}
        >
          {Object.keys(activeBoxes).map((key) => (
            <WindowTab
              id={key}
              {...activeBoxes[key].props}
              onClose={handleCloseVehiclePopout}
              onMinimise={revertBox}
              setShowDetails={setShowDetails}
              setDockAlign={setDockAlign}
              setDeviceId={setDeviceId}
              setShowTrack={setShowTrack}
              selectedVehiclePlate={selectedVehiclePlate}
              setHighlight={setHighlight}
              removeLayerOnClose={removeLayerOnClose}
              removeRowSelection={removeRowSelection}
            >
              {(currentTab === "Activities" || currentTab === "Trips" || currentTab === "Events") &&
                selectedVehiclePlate && (
                  <SelectedAssetSummary
                    plateNumber={selectedVehiclePlate}
                    cardType="Vehicles"
                    variant="plate"
                  />
                )}
              {currentTab === "Activities" ? (
                <Activities
                  deviceId={deviceId}
                  selectedRange={selectedRange}
                  clientId={clientId}
                  selectedVehiclePlate={selectedVehiclePlate}
                  type="Vehicles"
                />
              ) : currentTab === "Trips" ? (
                <TripsContainer
                  resetCount={globalResetCount}
                  setResetCount={setGlobalResetCount}
                  deviceId={deviceId}
                  selectedRange={selectedRange}
                  setSelectedRange={selectedRangeHistory}
                  clientId={clientId}
                  selectedVehiclePlate={selectedVehiclePlate}
                  type="Vehicles"
                  setMapSelectionLoading={setMapSelectionLoading}
                />
              ) : currentTab === "Events" ? (
                <EventsContainer
                  resetCount={globalResetCount}
                  setResetCount={setGlobalResetCount}
                  deviceId={deviceId}
                  selectedRange={selectedRange}
                  setSelectedRange={selectedRangeHistory}
                  clientId={clientId}
                  selectedVehiclePlate={selectedVehiclePlate}
                  type="Vehicles"
                  setDeviceId={setDeviceId}
                  setDockAlign={setDockAlign}
                  setMapPoint={setMapPoint}
                  setShowEventsDetails={setShowEventsDetails}
                />
              ) : currentTab === "Graphs" ? (
                <GraphsContainer
                  deviceId={deviceId}
                  selectedVehiclePlate={selectedVehiclePlate}
                  type="Vehicles"
                />
              ) : currentTab === "TrackPoints" ||
                currentTab === "LiveTrack" ||
                (currentTab === "Map" && liveDetailsBlockView === "TrackPoints") ? (
                <>
                  {toggleTrackPointTab ? (
                    <RawData
                      deviceId={deviceId}
                      selectedRange={selectedRange}
                      decode={decode}
                      order={order}
                    />
                  ) : currentTab === "Map" ? (
                    <LiveTrackPoints
                      clearSelectionKey={mapResetCount}
                      deviceId={deviceId}
                      liveData={realTimedata}
                      onRoutePackets={handleRoutePackets}
                      telemetry={canonicalTelemetry}
                      selectedVehiclePlate={selectedVehiclePlate}
                      selectedRange={selectedRangeLive}
                      setResetCount={setResetCount}
                      type="Vehicles"
                      currentTab={currentTab}
                      setSelectedTrackPointData={setSelectedTrackPointData}
                      setLiveDetailsBlockView={setLiveDetailsBlockView}
                      deviceData={deviceData}
                      setTrackpointsHistoryData={setLiveRoutePoints}
                      setIsTrackPointsHistoryDataCollected={setIsTrackPointsHistoryDataCollected}
                      skipQuery={!liveRangeReady}
                    />
                  ) : (
                    <HistoryTrackPoints
                      deviceId={deviceId}
                      setDeviceId={setDeviceId}
                      liveData={realTimedata}
                      selectedVehiclePlate={selectedVehiclePlate}
                      selectedRange={selectedRangeHistory}
                      setResetCount={setResetCount}
                      setMapPoint={setMapPoint}
                      setDockAlign={setDockAlign}
                      type="Vehicles"
                      currentTab={currentTab}
                      setSelectedTrackPointData={setSelectedTrackPointData}
                      setLiveDetailsBlockView={setLiveDetailsBlockView}
                      deviceData={deviceData}
                      setTrackpointsHistoryData={setTrackpointsHistoryData}
                    />
                  )}
                </>
              ) : isPluginTab ? (
                <PluginContainer selectedPlugin={selectedPlugin} />
              ) : (
                <VehicleDetailsWindowView
                  realTimedata={realTimedata}
                  type="Vehicles"
                  deviceId={deviceId}
                  deviceData={deviceData}
                  clientConfig={clientConfig}
                  selectedVehiclePlate={selectedVehiclePlate}
                  summaryDetails={
                    <HeaderDetails
                      realTimedata={realTimedata}
                      deviceData={deviceData}
                      deviceId={deviceId}
                      selectedVehiclePlate={selectedVehiclePlate}
                      telemetry={canonicalTelemetry}
                      type="Vehicles"
                    />
                  }
                  listDetails={
                    <ListDetails
                      clientConfig={clientConfig}
                      realTimedata={realTimedata}
                      deviceData={deviceData}
                      deviceId={deviceId}
                      currentTab={currentTab}
                      selectedVehiclePlate={selectedVehiclePlate}
                      type="Vehicles"
                    />
                  }
                />
              )}
            </WindowTab>
          ))}
        </Dnd>
      )}
      <ToastContainer />
    </>
  );
};
